import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    projects: {
      name: "Projet |||| Projets",
      fields: {
        name: "Projet",
        category: "Catégorie",
        structure_type: "Ouvrage",
        country: "Pays",
        region: "Région",
        city: "Ville",
        phase: "Phase",
        budget_amount: "Budget",
        funding: "Financement",
        start_date: "Début des travaux",
        end_date: "Fin des travaux",
        score: "Score",
        source_published_at: "Source",
        phase_contradiction: "Phase contredite",
        last_news_at: "Source",
      },
      hide_other: "Masquer « Autre »",
      amount: {
        title: "Montant",
        min: "Au moins",
        include_unknown: "Garder les fiches sans montant",
        estimate:
          "Estimation dans la monnaie de votre compte, au dernier cours connu ; la source donne le montant dans sa devise",
      },
      map: {
        view: "Affichage",
        view_list: "Liste",
        view_map: "Carte",
        label: "Carte des projets",
        loading: "Chargement des fiches…",
        placed:
          "%{smart_count} fiche sur la carte |||| %{smart_count} fiches sur la carte",
        unplaced:
          "%{smart_count} fiche sans pays, pas sur la carte |||| %{smart_count} fiches sans pays, pas sur la carte",
        anchored:
          "%{smart_count} fiche sans ville, au repère de son pays |||| %{smart_count} fiches sans ville, au repère de leur pays",
        country_anchor:
          "%{country} · ville inconnue, %{smart_count} fiche |||| %{country} · ville inconnue, %{smart_count} fiches",
        limited: "Limitée aux %{limit} fiches les mieux notées",
        city_position: "Position de la ville, pas du chantier",
        legend_show: "Afficher le détail de la légende",
        legend_hide: "Masquer le détail de la légende",
        same_city:
          "%{smart_count} fiche à cet endroit |||| %{smart_count} fiches à cet endroit",
        empty:
          "Aucune fiche de cette sélection n'a de ville placée. Les villes viennent de GeoNames, déposé dans l'écran « Imports ».",
      },
      list_header: {
        count: "%{smart_count} fiche |||| %{smart_count} fiches",
        show_list: "Passer en vue liste pour les parcourir toutes",
        hide_other: "Sans « Autre »",
        min_score: "Score ≥ %{value}",
        min_eur: "Montant ≥ %{value} M€",
        min_eur_or_unknown: "Montant ≥ %{value} M€ ou inconnu",
        max_eur: "Montant ≤ %{value} M€",
        created_after: "Détectées depuis le %{date}",
        created_before: "Détectées avant le %{date}",
        news_after: "Nouvelle depuis le %{date}",
        to_specify: "À préciser",
        other: "Autre filtre",
        more: "Plus d'actions",
        remove: "Retirer le filtre %{label}",
      },
      country_search: "Chercher un pays",
      country_none: "Aucun pays",
      country_all: "Tous les pays (%{count})",
      country_less: "Moins de pays",
      categories: {
        water: "Eau",
        tunnels_rail: "Tunnels et ferroviaire",
        bridges_parking: "Ponts et parkings",
        buildings: "Grands bâtiments",
        other: "Autre",
      },
      phases: {
        concept: "Concept",
        feasibility_study: "Étude de faisabilité",
        design: "Conception",
        tender: "Appel d'offres",
        awarded: "Attribué",
        pre_construction: "Pré-construction",
        construction: "Construction",
        completed: "Terminé",
      },
      roles: {
        client_project_owner: "Maître d'ouvrage",
        developer: "Promoteur",
        main_contractor: "Entreprise principale",
        general_contractor: "Entreprise générale",
        epc_contractor: "Entreprise EPC",
        civil_contractor: "Entreprise de génie civil",
        waterproofing_contractor: "Entreprise d'étanchéité",
        engineering_company: "Bureau d'études",
        architect: "Architecte",
        design_consultant: "Consultant en conception",
        waterproofing_consultant: "Consultant en étanchéité",
        concrete_consultant: "Consultant béton",
        project_management_company: "Maîtrise d'œuvre",
        local_distributor_or_supplier: "Distributeur ou fournisseur local",
        funder: "Bailleur de fonds",
      },
      methods: {
        extracted: "Cité dans la source",
        inferred: "Déduit par l'IA, sans citation dans la source",
        entered: "Saisi par un utilisateur",
      },
      sections: {
        facts: "Données du projet",
        companies: "Sociétés et rôles",
        sources: "Sources",
        sources_count: "Sources (%{smart_count})",
      },
      to_specify: "à préciser",
      original_name: "Nom dans la source : %{name}",
      score: {
        title: "Score ETT",
        not_scored: "Score pas encore calculé.",
        out_of: "sur 100",
        ai_note:
          "Résumé et critères marqués IA : évaluation par l'IA à partir des sources (confiance %{confidence} %).",
        provisional: "Pondérations provisoires, à régler.",
        to_specify:
          "À préciser : la fiche n'indique pas de pays, ou ni ville ni société. Score plafonné en attendant une source plus précise ; les critères donnent %{uncapped}.",
        capped:
          "Score plafonné, car le chantier est avancé ou le montant est faible : les critères donnent %{uncapped}.",
        capped_no_city:
          "Score plafonné, car la fiche n'indique pas de ville : on ne sait pas où aller voir. Les critères donnent %{uncapped}.",
        points: "%{points} / %{weight}",
        by_ai: "IA",
        stamp: "Règles + IA",
        stamp_title:
          "Score calculé par des règles et une évaluation de l'IA à partir des sources",
        details: "Détail des critères",
        unknown: "Information absente : aucun point.",
        amount: "Montant d'environ %{amount}",
        surface: "Surface citée dans la source : %{surface} m²",
        need: "Besoin produit estimé : %{litres} litres",
        criteria: {
          water_contact: "Contact avec l'eau, pression",
          waterproofing_need: "Besoin d'étanchéité",
          structure_type: "Type d'ouvrage",
          size: "Taille du projet",
          phase: "Stade du projet",
          membrane_replacement: "Remplacement d'une membrane",
          access_difficulty: "Difficulté d'accès",
        },
      },
      companies_show_more:
        "Voir l'autre société |||| Voir les %{smart_count} autres sociétés",
      no_companies: "Aucune société identifiée dans les sources.",
      duplicates: {
        title: "Doublons à valider",
        intro:
          "Ces fiches décrivent peut-être le même projet. Ni les règles ni l'IA n'ont pu trancher.",
        empty: "Aucune paire en attente.",
        forbidden: "Écran réservé au responsable des imports.",
        button:
          "%{smart_count} doublon à valider |||| %{smart_count} doublons à valider",
        same: "Même projet : fusionner",
        different: "Projets différents",
        rule_note: "Noms ressemblants à %{similarity} % : %{reason}.",
        ai_note: "Avis de l'IA (confiance %{confidence} %) : %{note}",
        document: "%{date} · %{title}",
        merge_recorded:
          "Décision enregistrée. Les deux fiches seront fusionnées au prochain passage du rapprochement.",
        rejected: "Décision enregistrée. Cette paire ne sera plus proposée.",
      },
      company_projects: "%{smart_count} projet |||| %{smart_count} projets",
      switchboard: {
        label: "Standard :",
        found: { site: "lu sur son site", manual: "saisi" },
        contact: "Standard de la société :",
        help: "Numéro général de la société, gratuit : demandez la personne par son nom.",
      },
      site: {
        found: {
          notice: "lu dans un avis",
          wikidata: "trouvé par Wikidata",
          search: "trouvé par Aubeon",
          manual: "saisi",
          unknown: "provenance inconnue",
        },
        on: "le %{date}",
        source: "source",
        report: {
          action: "Signaler une erreur",
          title: "Signaler ce site comme faux",
          help: "Il est retiré de la société pour tous, ne sera plus proposé, et le responsable des données est prévenu. Une prochaine recherche de contacts cherchera un autre site.",
          note: "Ce qui ne va pas (facultatif), par exemple : site d'un homonyme",
          confirm: "Retirer ce site",
          cancel: "Annuler",
          done: "Site retiré, merci : le responsable des données est prévenu.",
        },
      },
      contacts: {
        title: "Contacts",
        copy_email: "Copier l'e-mail",
        copied: "Adresse copiée",
        copy_failed: "Copie impossible",
        sent_prompt: "Message envoyé à %{name} ?",
        sent_yes: "Oui",
        sent_later: "Plus tard",
        relation: {
          contacted: "Contacté",
          in_touch: "En échange",
          specifier: "Prescripteur acquis",
          set_specifier: "Prescripteur acquis",
          unset_specifier: "Retirer « prescripteur »",
        },
        search:
          "Chercher les contacts · %{smart_count} crédit par e-mail |||| Chercher les contacts · %{smart_count} crédits par e-mail",
        search_again:
          "Relancer la recherche · %{smart_count} crédit par e-mail |||| Relancer la recherche · %{smart_count} crédits par e-mail",
        pending: "Recherche en cours…",
        pending_help:
          "Selon la difficulté à trouver les contacts, la recherche peut prendre jusqu'à 3 minutes. Vous pouvez quitter cette page et y revenir : les contacts trouvés s'y afficheront.",
        requested:
          "Recherche demandée : les contacts apparaîtront ici dans quelques minutes.",
        empty: "Aucun contact pour cette fiche.",
        show_more:
          "Voir l'autre contact |||| Voir les %{smart_count} autres contacts",
        last_search:
          "Dernière recherche le %{date} : %{smart_count} contact ajouté. |||| Dernière recherche le %{date} : %{smart_count} contacts ajoutés.",
        last_error: "La recherche du %{date} a échoué.",
        guessed: {
          valid: "(adresse déduite, confirmée par le serveur de messagerie)",
          catch_all:
            "(adresse déduite du format de la société, le serveur accepte toute adresse)",
          unknown: "(adresse déduite du format de la société, non vérifiée)",
        },
        probable: {
          label: "Probable",
          button: "E-mail probable · gratuit",
          button_help:
            "Adresse construite d'après le format habituel de la société. Son serveur ne permet pas de la vérifier : à utiliser avec prudence.",
          warning_title: "Adresse probable, non vérifiée",
          warning_company:
            "Elle est construite d'après le format lu sur d'autres adresses de la société.",
          warning_common:
            "Elle est construite d'après le format le plus courant (prénom.nom) : aucune adresse de cette société n'est connue.",
          warning_server:
            "Le serveur de messagerie de la société ne dit pas si cette adresse existe. Un message envoyé à une adresse fausse peut se perdre sans aucun retour d'erreur.",
          warning_advice:
            "Pour une adresse vérifiée, utilisez « E-mail vérifié » : le crédit n'est débité que si nos fournisseurs en trouvent une.",
          warning_silence: "Ne plus me prévenir",
          warning_show: "Afficher l'adresse",
          help: "Adresse déduite que personne ne peut vérifier : le serveur de messagerie de la société ne dit pas quelles adresses existent. Gratuite, elle ne compte pas comme un e-mail trouvé.",
          unverifiable:
            "Non vérifiable : le serveur de la société ne dit pas quelles adresses existent.",
          company: "Format lu sur d'autres adresses de la société.",
          common:
            "Format le plus courant (prénom.nom), aucune adresse de la société connue.",
          providers: "Nos fournisseurs connaissent aussi cette adresse.",
        },
        provided: {
          valid: "(adresse trouvée via nos fournisseurs, vérifiée)",
          catch_all:
            "(adresse trouvée via nos fournisseurs, le serveur accepte toute adresse)",
        },
        email_status: {
          verified: "confirmée par son serveur le %{date}",
          published: "adresse écrite sur cette page, lue le %{date}",
        },
        tools: {
          both: "Place dans la chaîne, signaler une erreur",
          place: "Place dans la chaîne",
          report: "Signaler une erreur",
        },
        report: {
          action: "Signaler une erreur · gratuit",
          phone: "Téléphone",
          title: "Qu'est-ce qui ne va pas ?",
          reasons: {
            unrelated: "Contact sans rapport avec ce projet",
            left: "A quitté sa société",
            email: "Mauvais e-mail",
            phone: "Mauvais numéro",
            linkedin: "Mauvais LinkedIn",
          },
          effect_unrelated:
            "La personne est retirée de cette fiche pour votre équipe, et la recherche ne l'y remettra pas.",
          effect_left:
            "La personne est retirée de toutes les fiches de votre équipe, et la recherche ne l'y remettra pas.",
          effect_email:
            "L'adresse est retirée pour votre équipe et ne vous sera plus proposée. Les crédits déjà dépensés ne sont pas rendus.",
          effect_phone:
            "Le numéro est retiré pour votre équipe et ne vous sera plus proposé. Les crédits déjà dépensés ne sont pas rendus.",
          effect_linkedin:
            "Le profil est retiré pour votre équipe et ne vous sera plus proposé.",
          note: "Précision (facultatif), par exemple : message revenu en erreur",
          confirm: "Signaler",
          cancel: "Annuler",
          done_unrelated:
            "Contact retiré de la fiche, merci : le responsable des données est prévenu.",
          done_left:
            "Contact retiré de vos fiches, merci : le responsable des données est prévenu.",
          done_email:
            "Adresse retirée, merci : le responsable des données est prévenu.",
          done_phone:
            "Numéro retiré, merci : le responsable des données est prévenu.",
          done_linkedin:
            "Profil retiré, merci : le responsable des données est prévenu.",
        },
        notes: {
          no_email: "Aucune adresse trouvée.",
          no_mobile: "Aucun mobile trouvé.",
          no_linkedin: "Aucun profil LinkedIn trouvé.",
          known_email: "Adresse déjà connue.",
          missing_name:
            "Prénom, nom ou société manquant : recherche impossible.",
          suppressed: "Contact sur la liste d'opposition.",
          company_suppressed: "Société sur la liste d'opposition.",
          unavailable:
            "Recherche indisponible pour le moment, aucun crédit débité.",
          budget_sites:
            "Plafond IA du mois atteint : les sites des sociétés n'ont pas été lus.",
          budget_chain:
            "Plafond IA du mois atteint : la chaîne de décision n'a pas été proposée.",
          suppressed_count:
            "%{count} contact(s) écarté(s) : liste d'opposition.",
          missed: "Déjà cherché sans résultat il y a moins de %{count} jours.",
          no_company:
            "Aucune société connue pour ce projet, même après une recherche sur le web : faites-vous alerter quand le radar en trouvera une.",
          probable_missed:
            "Nos fournisseurs n'ont pas d'adresse vérifiée : rien n'est débité. L'adresse probable reste la meilleure piste.",
          probable_known:
            "Nos fournisseurs connaissent aussi l'adresse probable, sans pouvoir la vérifier : rien n'est débité.",
          landline_only:
            "Seule une ligne fixe a été trouvée, gardée sur la fiche : rien n'est débité.",
        },
        lookup: {
          fresh: "trouvé le %{date}",
          button: {
            email:
              "E-mail · %{smart_count} crédit |||| E-mail · %{smart_count} crédits",
            email_verified:
              "E-mail vérifié · %{smart_count} crédit |||| E-mail vérifié · %{smart_count} crédits",
            mobile:
              "Mobile · %{smart_count} crédit |||| Mobile · %{smart_count} crédits",
            linkedin: "LinkedIn · gratuit",
          },
          email:
            "Trouver l'e-mail · %{smart_count} crédit |||| Trouver l'e-mail · %{smart_count} crédits",
          email_verified:
            "Nos fournisseurs cherchent une adresse vérifiée ou différente de l'adresse probable · %{smart_count} crédit, débité seulement dans ce cas |||| Nos fournisseurs cherchent une adresse vérifiée ou différente de l'adresse probable · %{smart_count} crédits, débités seulement dans ce cas",
          linkedin: "Trouver le LinkedIn · gratuit",
          mobile:
            "Trouver le mobile · %{smart_count} crédit |||| Trouver le mobile · %{smart_count} crédits",
          running: "%{kind} : recherche en cours…",
          short:
            "Crédits insuffisants (%{kinds}) : il faut au moins %{price} crédit(s), %{available} disponible(s). Demandez-en à un administrateur.",
          joins_contacts:
            "Trouvée, la personne rejoindra les contacts de la fiche.",
          pending: "Recherche en cours…",
          requested:
            "Recherche demandée, résultat dans une ou deux minutes. Vous pouvez quitter cette page et y revenir : le résultat s'y affichera.",
          kinds: {
            email: "E-mail",
            linkedin: "LinkedIn",
            mobile: "Mobile",
          },
          result: "%{kind}, recherche du %{date} : %{note}",
          result_short: "recherche du %{date} : %{note}",
          found: "trouvé",
        },
        team: {
          title: "Équipe des sociétés",
          fold: "Trouver d'autres personnes",
          short:
            "Crédits insuffisants : il faut %{price} crédits, %{available} disponible(s). Demandez-en à un administrateur.",
          company_title: "Équipe de la société",
          help: "Personnes en poste dans la société, aux achats, aux projets, à l'ingénierie, sur les chantiers et à la direction, d'après leur profil public, trouvées via nos fournisseurs. %{smart_count} crédit, débité seulement si au moins une personne est ajoutée. |||| Personnes en poste dans la société, aux achats, aux projets, à l'ingénierie, sur les chantiers et à la direction, d'après leur profil public, trouvées via nos fournisseurs. %{smart_count} crédits, débités seulement si au moins une personne est ajoutée.",
          button:
            "Chercher l'équipe · %{smart_count} crédit |||| Chercher l'équipe · %{smart_count} crédits",
          pending: "Recherche de l'équipe en cours…",
          requested:
            "Recherche de l'équipe demandée, résultat dans quelques minutes. Vous pouvez quitter cette page et y revenir : les personnes trouvées s'y afficheront.",
          result:
            "Recherche du %{date} : %{smart_count} personne ajoutée. |||| Recherche du %{date} : %{smart_count} personnes ajoutées.",
          members:
            "Équipes des sociétés : %{smart_count} personne sans e-mail ni place dans la chaîne |||| Équipes des sociétés : %{smart_count} personnes sans e-mail ni place dans la chaîne",
          from_company:
            "Les personnes trouvées rejoignent les contacts de la société et la fiche « %{project} ».",
          members_help:
            "Nom, fonction et profil trouvés via nos fournisseurs. Une personne rejoint la liste des contacts dès qu'elle a un e-mail ou une place dans la chaîne.",
          filter: "Filtrer par fonction ou par nom (compras, proyecto…)",
          moved_email:
            "%{name} : e-mail trouvé, la personne est passée dans les contacts de la fiche.",
          moved_phone:
            "%{name} : téléphone trouvé, la personne est passée dans les contacts de la fiche.",
          moved_other: "%{name} est passé·e dans les contacts de la fiche.",
          see: "↑ Voir",
          joined_email: "Nouveau · e-mail trouvé le %{date}",
          joined_phone: "Nouveau · téléphone trouvé le %{date}",
        },
        source: "Source, relevée le %{date}",
        linkedin: "Profil LinkedIn",
        linkedin_found: "trouvé par Aubeon le %{date}, profil non lu",
        linkedin_provider: "trouvé via nos fournisseurs",
        credits:
          "La recherche est gratuite ; seul chaque e-mail de personne obtenu pour la première fois sur cette fiche coûte %{price} crédit, quelle que soit la façon dont il a été trouvé. Les recherches d'e-mail ou de mobile d'une personne ne sont débitées que si la donnée est trouvée.",
        credits_short:
          "Crédits insuffisants : il faut au moins %{price} crédit pour lancer une recherche, %{available} disponible(s). Demandez-en à un administrateur.",
        on_project: {
          label: "Sur ce projet",
          help: "Sa fonction cite « %{word} » : elle travaille sur ce projet, pas seulement dans la société.",
        },
        funder: {
          label: "Bailleur — information",
          help: "Finance le projet sans choisir les produits : utile pour connaître l'avancement et l'organisme qui réalise, pas pour prescrire.",
        },
        decision: {
          title: "Chaîne de décision",
          help: "Proposée par l'outil d'après le rôle de chaque société sur le projet et la fonction de chaque personne. Corrigez-la si besoin : votre correction prime.",
          empty: "Personne n'a encore de place dans la chaîne.",
          label: "Place dans la chaîne",
          roles: {
            prescribes: "Prescrit",
            validates: "Valide",
            buys: "Achète",
            applies: "Applique",
            none: "Aucune place",
          },
          inferred: "proposé par l'outil, confiance %{confidence} %",
          short_confidence: " · %{confidence} %",
          to_check: " · à vérifier",
          place_of: "Place de %{name} dans la chaîne de décision",
          manual: "corrigé le %{date}",
          not_assessed: "pas encore évalué",
          saved: "Place dans la chaîne enregistrée",
        },
        kinds: { person: "Personne", service: "Service" },
      },
      references: {
        title: "Références de chantiers",
        intro:
          "Chantiers où l'ETT a été employée, que l'assistant peut citer comme preuve dans un premier message. Il ne cite que celles-ci, et seulement si le type d'ouvrage correspond.",
        empty:
          "Aucune référence de chantier enregistrée : les messages ne citent donc aucune preuve. Ils sont plus convaincants avec 2 ou 3 références.",
        empty_ask:
          "Aucune référence de chantier enregistrée : les messages ne citent donc aucune preuve. Demandez à un administrateur d'en ajouter 2 ou 3.",
        count:
          "%{smart_count} référence de chantier |||| %{smart_count} références de chantiers",
        add: "Ajouter une référence",
        remove: "Retirer la référence",
        read_only:
          "Seuls les administrateurs de l'équipe ajoutent ou retirent des références.",
        fields: {
          title: "Chantier",
          structure_type: "Type d'ouvrage",
          country: "Pays",
          year: "Année",
          replaced: "Ce que l'ETT a remplacé",
          result: "Résultat constaté",
          source_url: "Lien (facultatif)",
        },
        placeholders: {
          title: "ex. Station d'épuration de …",
          structure_type: "ex. Bassin, réservoir, tunnel, parking…",
          country: "ex. France",
          year: "ex. 2024",
          replaced: "ex. Membrane d'étanchéité du bassin",
          result: "ex. Aucune infiltration après deux ans",
          source_url: "https://…",
        },
      },
      assistant: {
        title: "Assistant",
        intro:
          "Rédigé par IA à partir des seules informations sourcées de la fiche. À relire avant usage : rien n'est envoyé.",
        brief: "Analyser la fiche",
        summary: "Le projet",
        why_relevant: "Intérêt pour l'ETT",
        who_first: "Qui contacter en premier",
        draft_title: "Premier message",
        recipient: "Destinataire",
        no_recipient:
          "Cherchez d'abord les contacts de la fiche pour rédiger un message.",
        formats: { email: "E-mail", linkedin: "Message LinkedIn" },
        language: "Langue",
        languages: {
          auto: "Langue du pays du projet",
          fr: "Français",
          en: "Anglais",
        },
        draft: "Rédiger",
        subject: "Objet",
        body: "Message",
        copy: "Copier",
        copied: "Texte copié",
        linkedin_help:
          "À coller dans LinkedIn depuis votre compte : l'outil ne s'y connecte pas.",
        connection_note: "Note de la demande de connexion",
        characters: "%{count} / %{max} caractères",
        linkedin_body: "Message, une fois la connexion acceptée",
        connection_sent:
          "Demande de connexion envoyée à %{name} ? Le message ci-dessous sera gardé sur l'affaire, avec un rappel le %{date}.",
        connection_replaces: "Remplace la prochaine action : %{action}",
        connection_yes: "Oui, me rappeler le message",
        connection_follow: "Suivre ce projet et me rappeler le message",
        connection_request: "Demande de connexion",
        connection_reminder_saved: "Rappel noté pour le %{date}",
        hook: "Accroche : « %{hook} » (%{origin})",
        no_hook:
          "Aucune accroche sûre trouvée : le message part du projet. Ajoutez-en une si vous connaissez la personne.",
        hook_origins: {
          project: "d'après la fiche",
          person: "d'après la personne",
          company: "d'après sa société",
          reference: "d'après vos références",
        },
        from_base: "base du radar",
        signals: "Informations utilisées",
        inferred: "déduit",
        assessment: "évaluation de l'outil",
        source: "source du %{date}",
        working: "Rédaction en cours…",
      },
      export: {
        file: "projets-radar",
        xlsx: "Excel (.xlsx)",
        csv: "CSV",
        score: "Score",
        name: "Projet",
        category: "Catégorie",
        structure_type: "Type d'ouvrage",
        phase: "Phase",
        country: "Pays",
        region: "Région",
        city: "Ville",
        owners: "Maîtres d'ouvrage",
        amount: "Montant",
        currency: "Devise",
        amount_eur: "Montant en euros (estimation, cours BCE)",
        funding: "Financement",
        start_date: "Début",
        end_date: "Fin",
        source: "Source",
        source_url: "Lien vers la source",
        published_at: "Publiée le",
        last_news_at: "Dernière nouvelle le",
        detected_at: "Détectée le",
        aegyra_id: "Identifiant AEGYRA",
        link: "Fiche dans le radar",
        deals_file: "affaires-radar",
        deal_name: "Affaire",
        stage: "Étape",
        deal_company: "Société de l'affaire",
        manager: "Responsable",
        next_action: "Prochaine action",
        next_action_type: "Type de la prochaine action",
        next_action_date: "Prévue le",
        last_activity: "Dernier échange",
        deal_amount: "Montant de l'affaire",
        project_name: "Fiche suivie",
        created_at: "Créée le",
        updated_at: "Modifiée le",
        deal_link: "Affaire dans le radar",
      },
      export_log: {
        title: "Journal des exports",
        menu: "Journal des exports",
        intro:
          "Chaque fichier exporté depuis le radar laisse ici une ligne : qui, quand, quelle liste, combien de lignes et avec quels filtres. Le journal ne peut pas être modifié.",
        empty: "Aucun export pour l'instant.",
        created_at: "Date",
        author: "Auteur",
        resource: "Liste",
        format: "Format",
        rows: "Lignes",
        filters: "Filtres",
        no_filter: "aucun",
        resources: {
          projects: "Projets",
          deals: "Affaires",
          contacts: "Contacts",
          companies: "Sociétés",
        },
      },
      health: {
        title: "Santé du radar",
        menu: "Santé du radar",
        intro:
          "Ce que le radar a fait chaque nuit, les sources qui ne rapportent plus et le parcours des recherches de contacts. Les chiffres viennent du journal des passages et des étapes de chaque recherche. Cette page n'est visible que de vous.",
        forbidden: "Cette page est réservée au responsable des imports.",
        nights_title: "Les %{count} dernières nuits",
        nights_empty:
          "Aucun passage noté pour l'instant : le journal commence à la prochaine nuit.",
        night: "Nuit",
        commands: "Commandes",
        contact_requests: "Recherches de contacts",
        llm_cost: "IA",
        provider_cost: "Moteur et fournisseurs",
        more_errors: "et %{count} autre(s) erreur(s)",
        failed_runs: "%{count} passage(s) en erreur",
        counters: {
          projects: "fiches comparées",
          confirmed: "fusions validées par un utilisateur",
          merged: "fusionnées",
          new_doubts: "nouveaux doutes",
          stale: "paires retirées",
          merge: "fusionnées",
          reject: "écartées",
          keep: "laissées à un utilisateur",
          postponed: "reportées",
          extracted: "extraits",
          not_relevant: "hors sujet",
          translated: "traduites",
          original_name: "avec leur nom d'origine",
          english_name: "renommées en anglais",
          missing: "sans réponse",
          searched: "cherchées",
          completed: "complétées",
          facts: "faits trouvés",
          recomputed: "scores recalculés",
          changed: "modifiés",
          assessed: "évaluées par IA",
          email_retries: "adresses réessayées",
          error: "erreurs",
        },
        status: { ok: "complète", partial: "incomplète", error: "en échec" },
        sources_title: "Sources à regarder",
        sources_intro:
          "En échec, qui ne retiennent plus rien depuis une semaine alors qu'elles retenaient avant, qui n'apportent plus rien de nouveau, ou qui n'ont rien retenu sur la période.",
        sources_empty:
          "Toutes les sources apportent et retiennent des documents.",
        source: "Source",
        reason: "Constat",
        inserted: "Nouveaux",
        kept_before: "Retenus avant",
        kept_recent: "Retenus sur 7 jours",
        reasons: {
          failing: "En échec",
          collapsed: "Ne retient plus rien",
          silent: "Plus rien de nouveau",
          never_kept: "Rien retenu sur la période",
        },
        funnel_title: "Recherches de contacts des %{count} derniers jours",
        funnel_intro:
          "Fiches fouillées, puis celles qui ont au moins une société, une société avec son site, une personne, un e-mail sûr (lu sur une page ou confirmé par le serveur) et une personne placée dans la chaîne avec un e-mail sûr. Source : la première qui a fait connaître la fiche.",
        funnel_empty: "Aucune recherche de contacts notée sur la période.",
        by_source: "Par source",
        by_country: "Par pays",
        country: "Pays",
        projects: "Fiches",
        steps: {
          companies: "Société",
          site: "Site",
          people: "Personne",
          email: "E-mail sûr",
          placed_email: "Placée + e-mail",
        },
        outcomes_title: "Issue de chaque étape (%{count} jours)",
        outcomes_intro:
          "Combien de fois chaque étape a abouti ou s'est arrêtée, et pourquoi les personnes et les profils lus ont été écartés.",
        rejected: "Écartés",
        step_names: {
          buyer_notice: "Contact des avis TED",
          worldbank_team: "Équipe Banque mondiale",
          companies: "Sociétés cherchées sur le web (fiche sans société)",
          site: "Site des sociétés",
          site_people: "Personnes lues sur les sites",
          linkedin: "Profils LinkedIn",
          project_people: "Responsables cherchés sur le web",
          email: "Adresse de chaque personne",
          chain: "Chaîne de décision",
          lookup: "Recherches par personne",
          summary: "Fiches fouillées",
        },
        outcomes: {
          found: "trouvé",
          none: "rien",
          not_found: "introuvable",
          error: "erreur",
          skipped: "non lancé",
          already_read: "déjà lu",
          already_searched: "déjà cherché",
          budget: "plafond atteint",
          no_page: "aucune page lisible",
          proposed: "proposée",
          confirmed: "confirmée par le serveur",
          published: "publiée sur une page",
          catch_all: "serveur qui accepte tout",
          unknown: "serveur sans réponse",
          temporary: "serveur indisponible",
          refused: "refusée par le serveur",
          retry: "à réessayer",
          check_limit: "plafond de vérifications",
          not_checked: "non vérifiée",
          no_site: "sans site",
          no_mail_domain: "site sans messagerie",
          suppressed: "liste d'opposition",
          stock: "trouvée dans le stock",
          provider: "trouvée chez le fournisseur",
        },
        rejections: {
          not_a_person: "pas une personne",
          name_not_on_page: "nom absent de la page",
          title_not_on_page: "fonction absente de la page",
          not_target_function: "fonction hors chantier",
          email_dropped: "e-mail retiré",
          phone_dropped: "téléphone retiré",
          not_a_profile: "pas un profil",
          foreign_country: "autre pays",
          not_at_company: "autre société",
          suppressed: "liste d'opposition",
          over_site_limit: "au-delà du plafond par site",
          over_company_limit: "au-delà du plafond par société",
        },
      },
      imports: {
        title: "Imports",
        menu: "Imports",
        intro:
          "Certaines sources refusent les robots mais publient leurs données en libre réutilisation. Leur fichier est téléchargé à la main (chaque mois pour l'ISVZ, chaque trimestre pour Kohesio, deux fois par an pour GeoNames) et déposé ici ; le radar le traite à la collecte suivante. Un rappel vous arrive quand un fichier est attendu. Cette page n'est visible que de vous.",
        forbidden: "Cette page est réservée au responsable des imports.",
        isvz_title: "République tchèque : registre des marchés publics (ISVZ)",
        step_download:
          "À partir du 6 du mois, télécharger le fichier « VZ » du mois précédent (VZ-MM-AAAA.zip, environ 180 Mo) sur la page des données ouvertes de l'ISVZ. Les autres fichiers (DNS, SON, SK…) ne servent pas.",
        open_data: "Données ouvertes de l'ISVZ",
        step_choose:
          "Le choisir ci-dessous. Votre navigateur le lit (environ une minute), garde les marchés de travaux au-dessus du seuil européen, sous le seuil et en procédure simplifiée, et n'envoie que ceux-là.",
        step_night:
          "La collecte de la nuit suivante garde les marchés récents et ceux qui touchent l'eau, les ponts, les tunnels, le rail ou les parkings, puis en fait des fiches. Le compte rendu arrive dans les alertes et dans le récapitulatif par e-mail.",
        choose: "Choisir le fichier du mois",
        privacy:
          "Aucun nom de personne n'est envoyé : seulement les acheteurs et les sociétés titulaires.",
        reading:
          "Lecture du fichier : %{contracts} marchés lus, %{kept} marchés de travaux retenus",
        sending: "Envoi : %{sent} marchés sur %{total}",
        sent: "%{total} marchés de %{period} envoyés. Ils seront traités à la collecte de la nuit prochaine.",
        failed: "L'import n'a pas abouti : %{error}",
        bad_name:
          "« %{name} » n'est pas un fichier VZ de l'ISVZ (nom attendu : VZ-MM-AAAA.zip).",
        no_json: "le ZIP ne contient aucun fichier JSON.",
        nothing_kept: "aucun marché de travaux retenu dans ce fichier.",
        history: "Imports déposés",
        empty: "Aucun import pour l'instant.",
        period: "Source · période",
        deposited: "Déposé le",
        records: "Lignes envoyées",
        status: "État",
        outcome: "Résultat",
        result: "%{kept} documents retenus, %{stale} marchés trop anciens",
        sources: {
          isvz: "ISVZ",
          geonames: "GeoNames",
          kohesio: "Kohesio",
          jpeia: "Études d'impact (Japon)",
          mirt: "MIRT Overzicht (Pays-Bas)",
          vib: "Verkehrsinvestitionsbericht (Allemagne)",
          rahmenplan: "ÖBB-Rahmenplan (Autriche)",
          kpk: "Krajowy Program Kolejowy (Pologne)",
          ntp: "Nasjonal transportplan (Norvège)",
          budjetti: "Budget de l'État finlandais (Väylävirasto)",
          standbericht: "Programmes ferroviaires suisses (OFT)",
          sfdi: "Budget du fonds tchèque des transports (SFDI)",
        },
        kohesio_title:
          "Union européenne : opérations de la politique de cohésion (Kohesio)",
        kohesio_step_download:
          "En janvier, avril, juillet et octobre, à partir du 6, télécharger les exports CSV par pays du dernier lot (un fichier par pays, nommé PAYS-pp21-27-AAAAMMJJ.csv, environ 660 Mo en tout) sur la page des données de Kohesio. Le serveur de Kohesio refuse l'adresse du radar : ce téléchargement ne peut pas être automatique.",
        kohesio_open: "Données de Kohesio",
        kohesio_step_choose:
          "Les choisir tous ensemble ci-dessous (versions CSV, pas Excel). Votre navigateur les lit (quelques minutes) et n'envoie que les opérations d'au moins 10 M€.",
        kohesio_step_night:
          "La collecte de la nuit suivante garde les opérations en cours, commencées depuis moins de trois ans, dans l'eau, le transport guidé ou un ouvrage nommé, puis en fait des fiches. Le compte rendu arrive dans les alertes.",
        kohesio_choose: "Choisir les exports par pays",
        kohesio_license:
          "Données Kohesio, Commission européenne, licence CC BY 4.0. Les bénéficiaires sont des organismes.",
        kohesio_reading:
          "Lecture des fichiers : %{operations} opérations lues, %{kept} d'au moins 10 M€",
        kohesio_sending: "Envoi : %{sent} opérations sur %{total}",
        kohesio_sent:
          "%{total} opérations du lot du %{batch} envoyées (trimestre %{period}). Elles seront traitées à la collecte de la nuit prochaine.",
        kohesio_bad_name:
          "« %{name} » n'est pas un export par pays de Kohesio (nom attendu : PAYS-pp21-27-AAAAMMJJ.csv).",
        kohesio_mixed:
          "les fichiers choisis viennent de lots différents : prendre tous les pays du même lot.",
        kohesio_nothing: "aucune opération d'au moins 10 M€ dans ces fichiers.",
        kohesio_result: "%{kept} opérations retenues sur %{records} envoyées",
        jpeia_title:
          "Japon : études d'impact des grands ouvrages (ministère de l'Environnement)",
        jpeia_step_read:
          "En janvier, avril, juillet et octobre, à partir du 6, cliquer sur « Lire les études d'impact ». Votre navigateur lit la liste des dossiers des cinq dernières années, puis le résumé des barrages, centrales hydrauliques, voies ferrées et grandes routes (une requête par seconde, environ une minute). Le site refuse l'adresse du radar : cette lecture ne peut pas être automatique.",
        jpeia_step_night:
          "La collecte de la nuit suivante en fait des fiches, au stade des études. Le compte rendu arrive dans les alertes.",
        jpeia_open: "Site des études d'impact",
        jpeia_choose: "Lire les études d'impact",
        jpeia_license:
          "Réseau d'information sur les études d'impact, ministère de l'Environnement du Japon, licence PDL 1.0.",
        jpeia_reading_list:
          "Lecture de la liste : %{read} dossiers lus, %{kept} retenus",
        jpeia_reading_details: "Lecture des résumés : %{details} sur %{kept}",
        jpeia_sending: "Envoi : %{sent} dossiers sur %{total}",
        jpeia_sent:
          "%{total} dossiers envoyés (trimestre %{period}). Ils seront traités à la collecte de la nuit prochaine.",
        jpeia_nothing: "aucun dossier retenu dans la liste.",
        jpeia_refused:
          "le site a refusé la lecture (%{error}). Réessayer plus tard ; s'il refuse encore, le signaler.",
        jpeia_result: "%{kept} dossiers retenus sur %{records} envoyés",
        mirt_result: "%{kept} fiches retenues sur %{records} lues",
        vib_result: "%{kept} projets retenus sur %{records} lus",
        rahmenplan_result: "%{kept} projets retenus sur %{records} lignes lues",
        kpk_result: "%{kept} projets retenus sur %{records} lignes lues",
        ntp_result: "%{kept} projets retenus par le filtre sur %{records} lus",
        budjetti_result:
          "%{kept} projets retenus par le filtre sur %{records} lus",
        standbericht_result:
          "%{kept} projets retenus par le filtre sur %{records} lus",
        sfdi_result: "%{kept} projets retenus par le filtre sur %{records} lus",
        geonames_title: "Villes de GeoNames : position des fiches sur la carte",
        geonames_step_download:
          "En janvier et en juillet, à partir du 6, télécharger cities1000.zip (villes de plus de 1 000 habitants, environ 10 Mo) sur la page des fichiers de GeoNames. Le serveur refuse les robots : ce téléchargement ne peut pas être automatique.",
        geonames_open: "Fichiers de GeoNames",
        geonames_step_choose:
          "Le choisir ci-dessous. Votre navigateur le lit (quelques secondes) et envoie les villes, leur position et leurs noms en alphabet latin.",
        geonames_step_night:
          "La nuit suivante, la liste des villes est remplacée et chaque fiche est placée sur sa ville, jamais au centre de son pays. Le compte rendu arrive dans les alertes.",
        geonames_choose: "Choisir cities1000.zip",
        groups_title: "Groupes de messagerie proposés",
        groups_intro:
          "Chaque mois, le radar relève les noms de titulaires qui reviennent sur plusieurs fiches et leur propose un domaine de messagerie. Un groupe accepté sert dès la recherche de contacts suivante : ses filiales sans site sont vérifiées sur ce domaine. Rien n'est utilisé sans votre accord ; un mot écarté n'est jamais reproposé.",
        groups_empty: "Aucune proposition en attente.",
        groups_counts: "%{companies} société(s), %{projects} fiches",
        groups_method_company_site: "Site d'une de ces sociétés",
        groups_method_wikidata: "Site officiel lu dans Wikidata",
        groups_source: "source",
        groups_accept: "Accepter",
        groups_reject: "Écarter",
        groups_accepted: "Groupes acceptés",
        groups_withdraw: "retirer",
        geonames_license: "Données GeoNames, licence CC BY 4.0.",
        geonames_reading: "Lecture du fichier : %{cities} villes lues",
        geonames_sending: "Envoi : %{sent} villes sur %{total}",
        geonames_sent:
          "%{total} villes envoyées (semestre %{period}). Elles seront rangées à la collecte de la nuit prochaine.",
        geonames_bad_name:
          "« %{name} » n'est pas le fichier attendu (nom attendu : cities1000.zip).",
        geonames_no_txt: "le ZIP ne contient aucun fichier texte.",
        geonames_too_few: "trop peu de villes lues dans ce fichier.",
        geonames_result:
          "%{places} villes rangées ; %{placed} fiches placées sur %{projects} avec une ville",
        statuses: {
          uploading: "Envoi interrompu",
          pending: "En attente de la nuit",
          running: "En cours",
          done: "Traité",
          error: "Erreur",
        },
      },
      daily_picks: {
        title: "Les 10 du jour",
        computed_today: "Choisies cette nuit",
        computed_on: "Choisies le %{date}",
        not_computed:
          "La sélection est faite chaque nuit : elle apparaîtra ici demain matin.",
        empty:
          "Rien de nouveau sur vos projets aujourd'hui : aucune phase qui avance, aucun titulaire ni contact trouvé.",
        to_specify: "À préciser",
        dismiss: "Écarter",
        dismiss_help: "Ne plus la proposer, sauf si sa phase avance",
        source: "Ouvrir la source",
        reasons: {
          new: "Nouvelle fiche",
          phase: "Passée en %{phase} le %{date}",
          contractor: "Titulaire connu : %{value}",
          owner: "Maître d'ouvrage connu : %{value}",
          budget: "Budget : %{value}",
          budget_unknown: "Budget connu",
          contact: "Contact joignable : %{value}",
          contact_unnamed: "Contact joignable trouvé",
        },
      },
      dashboard: {
        map_title: "Carte des fiches",
        map_legend_shade: "Plus de fiches",
        map_legend_deal: "Affaire suivie",
        map_hint: "Choisissez un pays pour voir ses chiffres.",
        map_projects: "%{smart_count} fiche |||| %{smart_count} fiches",
        map_high: "%{count} à %{score} ou plus",
        map_deals:
          "%{smart_count} affaire suivie |||| %{smart_count} affaires suivies",
        map_none: "Aucune fiche",
        map_open: "Voir la liste",
        title: "Tableau de bord",
        greeting: "Bonjour %{name}",
        intro:
          "Fiches de votre périmètre hors catégorie «\u00a0autre\u00a0», et affaires en cours. Les montants sont convertis dans la monnaie de votre compte au cours de la BCE : ce sont des estimations.",
        sources_line:
          "Radar alimenté par %{official} sources officielles (marchés publics, budgets de l'État, bailleurs, agences) et %{press} flux de presse spécialisée, relus chaque nuit.",
        projects: "Fiches détectées",
        projects_short: "Fiches",
        new_week: "Nouvelles depuis 7 jours",
        high_score: "Score de %{score} ou plus",
        high_score_short: "Score ≥ %{score}",
        countries: "Pays",
        value: "Valeur connue des projets",
        value_short: "Valeur connue",
        value_note:
          "Estimation sur %{smart_count} fiche chiffrée, cours BCE du %{date} |||| Estimation sur %{smart_count} fiches chiffrées, cours BCE du %{date}",
        follow_up: "Suivi commercial",
        deals_active: "Affaires en cours",
        deals_overdue: "Actions en retard",
        deals_without_action: "Affaires sans prochaine action",
        deals_idle: "Sans activité depuis %{days} jours",
        top_projects: "Projets à fort score",
        new_projects: "Nouveautés de la semaine",
        no_new: "Aucune fiche nouvelle depuis 7 jours.",
        see_all: "Tout voir",
        estimate: "Estimation",
        countries_ranking: "Classement des pays",
        countries_all: "Voir les %{count} pays",
        countries_less: "Voir les premiers seulement",
        country: "Pays",
      },
      teaser: {
        offers: "Voir les offres",
        sources:
          "Chaque information de cette fiche vient d'une source vérifiable : avis de marché, délibération, presse. Avec un abonnement, vous voyez les sources et leurs liens.",
        list_hidden:
          "%{count} projet de la base répond à ces filtres hors de votre accès |||| %{count} projets de la base répondent à ces filtres hors de votre accès",
        list_hidden_high: ", dont %{count} à 80 ou plus",
        countries_hint: "Nombre de projets recensés dans toute la base",
        contacts:
          "Avec un abonnement, cherchez les décideurs de ce projet et leurs coordonnées.",
        assistant_quota: "5 analyses par semaine avec votre accès.",
        assistant_limit:
          "Vos 5 analyses de la semaine sont utilisées. Avec un abonnement, analysez toutes vos fiches.",
        questions_counts:
          "Posez une question en langage courant : la réponse donne des nombres sur toute la base. Encore %{smart_count} question cette semaine. |||| Posez une question en langage courant : la réponse donne des nombres sur toute la base. Encore %{smart_count} questions cette semaine.",
        questions_lock:
          "Avec un abonnement, vous ouvrez ces projets, leurs sociétés et leurs contacts.",
        questions_none:
          "Vos 3 questions de la semaine sont posées. Avec un abonnement, posez toutes vos questions et ouvrez les projets.",
        interest_label: "Votre zone d'intérêt",
        interest_placeholder: "Choisir une zone ou un pays",
        interest_zones: "Zones",
        interest_countries: "Pays",
        interest_saved:
          "Zone enregistrée : la première sélection arrive demain matin",
        interest_hint:
          "Choisissez une zone ou un pays : chaque matin, vous verrez ici ce qui bouge dans la base, et le lundi, le nombre de nouveaux projets de la semaine.",
        teasers_none:
          "Rien n'a bougé hier dans votre zone, ou la première sélection arrive demain matin.",
        teasers_title: "Projets qui bougent dans votre zone",
        teasers_lock:
          "%{smart_count} projet de votre zone a bougé hier hors de votre accès. |||| %{smart_count} projets de votre zone ont bougé hier hors de votre accès.",
        bands: {
          "<10": "Moins de 10 M€",
          "10-100": "10 à 100 M€",
          "100-500": "100 à 500 M€",
          "500+": "Plus de 500 M€",
        },
        signals: {
          new: "Nouveau projet",
          phase: "Phase qui avance",
          contractor: "Titulaire connu",
          owner: "Maître d'ouvrage connu",
          budget: "Budget connu",
        },
      },
      help: {
        score: {
          title: "Le score ETT",
          body: "De 0 à 100 : à quel point le projet a besoin d'étanchéité du béton (contact avec l'eau, type d'ouvrage, taille, stade). Calculé par des règles et par l'IA à partir des sources. Il est plafonné quand le chantier est trop avancé, le montant faible ou la fiche imprécise ; la fiche en donne le détail.",
        },
        evidence: {
          title: "Sourcé ou déduit",
          body: "« Sourcé » : la valeur est citée mot pour mot dans un document que vous pouvez ouvrir. « Déduit » : l'IA l'a tirée des sources sans citation exacte, avec un niveau de confiance ; « À vérifier » quand il est faible.",
        },
        amount: {
          title: "Montants",
          body: "Le montant de la source fait foi, dans sa monnaie. La ligne « ≈ » le convertit dans la monnaie de votre compte au cours de référence de la BCE : c'est une estimation.",
        },
        amount_filter: {
          title: "Filtre de montant",
          body: "Compare le montant converti en euros au cours de la BCE. Beaucoup de fiches n'ont pas encore de montant : « Garder les fiches sans montant » évite de les perdre.",
        },
        phase: {
          title: "Phases",
          body: "Du plus tôt au plus tard : concept, étude de faisabilité, conception, appel d'offres, attribué, pré-construction, construction, terminé. On prescrit jusqu'à la pré-construction ; une fois le béton coulé, c'est trop tard. Une phase ne recule jamais, même si une source plus ancienne dit autre chose.",
        },
        category: {
          title: "Catégories",
          body: "Eau, tunnels et ferroviaire, ponts et parkings, grands bâtiments (au moins un sous-sol, 15 étages ou 50 M€) : les ouvrages béton visés. « Autre » regroupe les fiches qui n'entrent dans aucune de ces familles ; « Masquer « Autre » » les retire de la liste.",
        },
        sources: {
          title: "Sources",
          body: "Le document qui a fait connaître le projet, et sa date. « 2 sources » : le radar a rapproché plusieurs documents sur le même projet ; la fiche les liste tous.",
        },
        chain: {
          title: "Chaîne de décision",
          body: "Qui fait choisir le produit : qui le prescrit, qui valide, qui achète, qui l'applique. L'outil propose une place à chaque contact d'après sa société et sa fonction, avec sa confiance ; vous la corrigez si besoin.",
        },
        emails: {
          title: "Fiabilité des e-mails",
          body: "Sûr : lu sur une page ou confirmé par le serveur de messagerie. Déduit : construit sur le format d'adresse de la société, non confirmé. Probable : construite sur le format de la société, ou prénom.nom, quand son serveur ne dit pas quelles adresses existent ; gratuite, à utiliser avec prudence. « E-mail vérifié » demande alors à nos fournisseurs une adresse vérifiée ou différente, débitée seulement s'ils en trouvent une.",
        },
        daily: {
          title: "Les 10 du jour",
          body: "Chaque nuit, jusqu'à 10 fiches de votre périmètre qui ont bougé ces 3 derniers jours : phase qui avance, titulaire ou contact trouvé, budget, fiche nouvelle. Score de 60 au moins, 3 fiches par pays au plus. « Écarter » la retire, sauf si sa phase avance.",
        },
        follow: {
          title: "Suivre, surveiller, veille",
          body: "Suivre ce projet : crée une affaire dans votre pipeline, et vous êtes alerté de tout changement. M'alerter quand une société arrive : surveille la fiche sans créer d'affaire. Veille : signale les nouvelles fiches qui répondent à un filtre de la liste.",
        },
        partners: {
          title: "Partenaires",
          body: "Partager ouvre la fiche à un partenaire et lui montre les contacts que votre organisation y a trouvés. Transmettre l'affaire lui en confie le suivi ; votre organisation la voit toujours. Rien d'autre de votre travail ne lui est visible.",
        },
        country_value: {
          title: "Valeur connue",
          body: "Somme des montants connus des fiches du pays, convertis au cours de la BCE. Beaucoup de fiches n'ont pas de montant : c'est un minimum, pas la taille du marché.",
        },
      },
      watch: {
        watch: "M'alerter quand une société arrive",
        done: "Alerte activée : vous serez prévenu dans les alertes",
        missing:
          "Pas encore de société connue pour : %{families}. Le radar relit les sources chaque nuit.",
        active: "Alerte active : %{families}",
        stop: "Arrêter",
        settings_link: "Régler",
        settings_title: "Sociétés arrivées sur les fiches surveillées",
        settings_intro:
          "Depuis une fiche, « M'alerter quand une société arrive » vous prévient ici, et dans l'e-mail s'il est activé. Choisissez les rôles qui vous intéressent ; ils valent pour toutes vos fiches surveillées.",
        one_family:
          "Gardez au moins un rôle. Pour ne plus rien recevoir, arrêtez la surveillance des fiches.",
        families: {
          owner: "Maître d'ouvrage",
          design: "Conception",
          contractor: "Entreprises",
          other: "Autres",
        },
        family_roles: {
          owner: "Maître d'ouvrage, promoteur",
          design: "Bureau d'études, architecte, maîtrise d'œuvre, consultants",
          contractor:
            "Entreprise principale, générale, EPC, génie civil, étanchéité",
          other: "Bailleurs de fonds, distributeurs et fournisseurs locaux",
        },
        watched:
          "%{smart_count} fiche surveillée |||| %{smart_count} fiches surveillées",
        none: "Aucune fiche surveillée. Dans le bloc Sociétés d'une fiche : « M'alerter quand une société arrive ».",
        since: "depuis le %{date}",
      },
      alerts: {
        saved_search_hidden:
          "%{count} nouveau projet de la veille « %{search} » est hors de votre accès |||| %{count} nouveaux projets de la veille « %{search} » sont hors de votre accès",
        weekly_teaser:
          "%{count} nouveau projet cette semaine dans votre zone (%{area}) |||| %{count} nouveaux projets cette semaine dans votre zone (%{area})",
        teaser_high: "Dont %{count} à 80 ou plus",
        teaser_tenders: "%{count} appel d'offres |||| %{count} appels d'offres",
        title: "Alertes",
        intro:
          "Commentaires et mises à jour des partenaires, actions en retard, changements sur les fiches que vous suivez, sociétés arrivées sur les fiches que vous surveillez, nouveaux projets de vos veilles.",
        empty: "Aucune alerte.",
        mark_all_read: "Tout marquer comme lu",
        new: "Nouveau",
        project_shared: "%{who} (%{org}) vous a partagé « %{project} »",
        project_shared_deal:
          "%{who} (%{org}) vous a partagé « %{project} » et vous a transmis l'affaire",
        partnership_new: "%{who} (%{org}) vous a ajouté comme partenaire",
        partnership_ended: "%{org} a mis fin au partenariat",
        partnership_left: "%{who} a quitté le partenariat",
        a_partner: "Un partenaire",
        partner_note: "%{who} a commenté « %{subject} »",
        partner_follow: "%{who} suit « %{subject} »",
        partner_stage: "%{who} a passé « %{subject} » à l'étape %{stage}",
        partner_archive: "%{who} a archivé « %{subject} »",
        partner_update: "%{who} a mis à jour « %{subject} »",
        overdue: "Action en retard sur « %{subject} »",
        project_change: "Changement sur « %{subject} »",
        company_arrived: "Société arrivée sur « %{subject} »",
        tab_alerts: "Alertes",
        tab_settings: "Réglages",
        subscription_request: "%{who} demande un abonnement",
        next_action: "%{action}, prévue le %{date}",
        saved_search: "Nouveau projet pour la veille « %{search} »",
        score: "score %{score}",
        silent_source:
          "La source « %{source} » n'apporte plus rien depuis le %{date}",
        source_back:
          "La source en pause « %{source} » répond de nouveau (semaine du %{date})",
        mail_groups: "%{count} groupe(s) de messagerie proposé(s) : %{words}",
        mail_groups_body:
          "À accepter ou écarter dans l'écran « Imports » ; rien n'est utilisé sans votre accord.",
        source_back_body:
          "À rebrancher : relire ses conditions et son robots.txt",
        job_partial: "Passage « radar %{command} » du %{date} incomplet",
        job_error: "Passage « radar %{command} » du %{date} en échec",
        job_more: "et %{count} autre(s) erreur(s)",
        source_drop:
          "La source « %{source} » apporte des documents mais n'en retient plus aucun depuis le %{date}",
        source_drop_body: "Filtre ou contenu de la source à revoir",
        provider_low:
          "Solde %{provider} bas : %{balance} crédits, sous le seuil de %{threshold}",
        provider_low_body:
          "À recharger dans le tableau de bord du fournisseur ; à zéro, les e-mails et mobiles demandés ne sont plus cherchés chez lui.",
        import_due:
          "Fichier %{source} de %{period} à déposer dans les imports mensuels",
        import_due_body:
          "Le fichier du mois est publié : le télécharger et le choisir dans l'écran « Imports mensuels ».",
        import_due_yearly:
          "Nouvelle édition %{source} de %{period} à télécharger",
        import_due_yearly_body_vib:
          "Chercher « Verkehrsinvestitionsbericht für das Berichtsjahr %{year} » sur dip.bundestag.de (imprimés, « Unterrichtung »), puis le faire traiter sur le worker avec l'adresse du PDF : radar collect --source vib --file <adresse du PDF>.",
        import_due_yearly_body_rahmenplan:
          "Chercher « ÖBB-Rahmenplan %{year} » parmi les rapports « III » du Nationalrat sur parlament.gv.at, puis le faire traiter sur le worker avec l'adresse du dossier : radar collect --source rahmenplan --file <adresse du dossier>.",
        import_due_yearly_body_kpk:
          "Chercher le « Sprawozdanie z wykonania w %{year} roku » du Krajowy Program Kolejowy sur gov.pl (page du programme au ministère de l'Infrastructure), puis le faire traiter sur le worker avec l'adresse de la pièce : radar collect --source kpk --file <adresse de la pièce>.",
        import_due_yearly_body_budjetti:
          "Sur budjetti.vm.fi, ouvrir la proposition de budget %{year} (« Talousarvioesitys %{year} »), puis le poste 31.10.77 « Väyläverkon kehittäminen », et le faire traiter sur le worker avec l'adresse de la page du poste : radar collect --source budjetti --file <adresse de la page du poste>.",
        import_due_yearly_body_sfdi:
          "Sur sfdi.gov.cz (rubrique « Rozpočet SFDI »), copier l'adresse du fichier xlsx des annexes du budget %{year} approuvé (pièce « přílohy »), puis le faire traiter sur le worker : radar collect --source sfdi --file <adresse du fichier>.",
        import_due_yearly_body_standbericht:
          "Sur bav.admin.ch (page de l'aménagement ferroviaire), copier l'adresse du PDF « Kennzahlen %{year} » en allemand (annexe du « Standbericht %{year} - Eisenbahnausbauprogramme »), puis le faire traiter sur le worker : radar collect --source standbericht --file <adresse du PDF>.",
        import_due_yearly_body_mirt:
          "Télécharger le PDF « MIRT Overzicht » de l'année sur mirtoverzicht.nl (rubrique Documenten), puis le faire traiter sur le worker : radar collect --source mirt --file <fichier>.",
        import_done: "Import %{source} de %{period} traité",
        import_done_body:
          "%{kept} documents retenus sur %{records} marchés envoyés, %{stale} trop anciens.",
        import_error: "Import %{source} de %{period} en erreur",
        wrong_data: "%{who} signale une erreur : %{person}",
        wrong_data_body: "%{data} %{value} retiré du contact",
        wrong_site_body: "%{data} %{value} retiré de la société",
        wrong_data_unrelated:
          "Sans rapport avec la fiche : retiré de la fiche pour son équipe",
        wrong_data_left:
          "A quitté sa société : retiré des fiches de son équipe",
        report_confirm: "Retirer pour toutes les équipes",
        report_undo: "Annuler le signalement",
        report_confirmed: "Donnée retirée pour toutes les équipes.",
        report_undone:
          "Signalement annulé : la donnée ou le contact est remis.",
        report_is_confirmed: "Retiré pour toutes les équipes.",
        report_is_undone: "Signalement annulé.",
        wrong_data_fields: {
          email: "E-mail",
          phone: "Téléphone",
          linkedin: "Profil LinkedIn",
          website: "Site web",
        },
        last_error: "Dernière erreur : %{error}",
        digest: "Recevoir chaque matin un récapitulatif par e-mail",
        digest_help:
          "Un seul e-mail par jour, à %{email}, avec les alertes que vous n'avez pas encore lues. Rien n'est envoyé les jours sans alerte.",
        digest_on: "Récapitulatif par e-mail activé",
        digest_off: "Récapitulatif par e-mail désactivé",
        share_emails: "Recevoir un e-mail à chaque fiche partagée",
        share_emails_help:
          "Quand un partenaire vous partage une fiche ou vous ajoute comme partenaire, un e-mail part tout de suite à %{email}, avec le lien de la fiche.",
        share_emails_on: "E-mail à chaque partage activé",
        share_emails_off: "E-mail à chaque partage désactivé",
      },
      questions: {
        title: "Questions sur la base",
        intro:
          "Posez une question en langage courant sur les fiches de votre périmètre. Chaque chiffre vient de la base, calculé avec vos droits ; les fiches, sociétés, affaires et personnes citées s'ouvrent d'un clic.",
        placeholder: "Ex. : combien de projets d'eau en amont au Maroc ?",
        placeholder_short: "Votre question…",
        follow_up_placeholder: "Question de suivi…",
        history: {
          title: "Historique",
          new: "Nouvelle conversation",
          empty:
            "Aucune conversation pour l'instant. Vos questions s'enregistrent ici, visibles de vous seul.",
          today: "Aujourd'hui",
          yesterday: "Hier",
          week: "7 derniers jours",
          older: "Plus ancien",
          delete: "Effacer la conversation",
          delete_title: "Effacer cette conversation ?",
          delete_content:
            "Elle disparaît de votre historique et ses réponses sont effacées. Cette action est définitive.",
          deleted: "Conversation effacée",
          load_error: "Historique illisible : %{message}",
          not_found: "Cette conversation n'existe plus.",
          asked_on: "Réponse du %{date}, chiffres de ce jour-là",
          repeat: "Reposer la question",
          back: "Retour à la conversation",
        },
        ask: "Demander",
        ask_question: "Poser une question",
        working: "Recherche dans la base…",
        understood: "J'ai compris : %{interpretation}",
        discarded:
          "Réponse rédigée écartée : un chiffre ou un nom ne se retrouvait pas dans les résultats de la base. Voici les résultats eux-mêmes.",
        results:
          "Résultats de la base (%{smart_count} outil) |||| Résultats de la base (%{smart_count} outils)",
        see_in_list: "Voir dans la liste",
        see_in_list_partial: "Voir dans la liste (en partie)",
        missing_list: "Non repris dans la liste : %{keys}",
        watch: "Créer une veille",
        watch_done: "Veille créée",
        watch_saved:
          "Veille enregistrée : les nouvelles fiches correspondantes vous seront signalées chaque nuit.",
        watch_saved_partial:
          "Veille enregistrée, sans ces critères qu'une veille ne sait pas suivre : %{keys}.",
        missing_watch: "Non suivi par la veille : %{keys}",
        useful: "Réponse utile",
        not_useful: "Réponse pas utile",
        example_1:
          "Quels projets d'eau en amont au Maroc ont le meilleur score ?",
        example_2:
          "Quels maîtres d'ouvrage reviennent le plus souvent en France ?",
        example_3: "Quelles fiches ont changé de phase cette semaine ?",
        example_4: "Quelles affaires ont une action en retard ?",
        tools: {
          count_projects: "Comptage des fiches",
          search_projects: "Fiches",
          top_companies: "Sociétés",
          recent_changes: "Changements",
          list_deals: "Affaires",
          suggest_names: "Noms proches",
          find_people: "Personnes",
        },
        filter_keys: {
          words: "mots",
          any_words: "mots",
          zones: "zone",
          place: "ville ou région",
          company: "société",
          company_role: "rôle de la société",
          min_eur: "montant minimal",
          max_eur: "montant maximal",
          min_score: "score minimal",
          created_after: "date d'ajout",
          created_before: "date d'ajout",
          news_after: "date de dernière nouvelle",
          to_specify: "fiches à préciser",
          followed: "fiches suivies",
        },
      },
      saved_searches: {
        title: "Mes veilles",
        empty:
          "Aucune veille. Filtrez la liste des projets puis « Enregistrer en veille » : chaque nuit, les nouveaux projets correspondants vous seront signalés ici.",
        save: "Enregistrer en veille",
        dialog_intro:
          "Chaque nuit, les nouveaux projets qui correspondent à ces critères vous sont signalés dans les alertes, une seule fois chacun, parmi les fiches que vous pouvez voir.",
        no_list_filter:
          "Aucun filtre de la liste : précisez un score ou un montant.",
        name: "Nom de la veille",
        min_score: "Score minimal",
        min_budget: "Montant minimal (M€)",
        min_score_label: "score ≥ %{score}",
        min_budget_label: "≥ %{amount} M€",
        needs_criterion:
          "Il faut au moins un critère, sinon chaque nouveau projet déclencherait une alerte.",
        confirm: "Enregistrer",
        saved: "Veille enregistrée",
        delete: "Supprimer la veille",
      },
      partners: {
        title: "Partenaires et territoires",
        intro:
          "Les distributeurs et installateurs avec qui vous travaillez. Un partenaire invité est gratuit : il voit les fiches que vous lui partagez et les affaires que vous lui transmettez ; il passe abonné en souscrivant une formule, vous ne pouvez pas le faire à sa place.",
        none: "Aucun partenaire pour l'instant : invitez le premier.",
        suspended: "Suspendu",
        disable: "Suspendre",
        enable: "Réactiver",
        remove: "Retirer le partenariat",
        remove_title: "Retirer le partenariat de %{name} ?",
        remove_content:
          "Son compte devient celui d'un collaborateur : il verra toute la base et vos affaires. À réserver à une erreur de saisie ; pour couper son accès, suspendez-le.",
        offer_locked:
          "Un partenaire passe abonné quand il souscrit une formule : vous ne pouvez pas le faire à sa place.",
        region_hint:
          "Une région se compare au texte de la fiche : partagez la fiche si la source l'écrit autrement.",
        admin: "Administrateur",
        partner: "Partenaire",
        territories: "Territoires",
        no_territory:
          "Aucun territoire : seules les fiches partagées sont visibles.",
        country: "Pays (FR)",
        region: "Région (facultatif)",
        add_territory: "Ajouter",
        assigned:
          "%{smart_count} fiche partagée |||| %{smart_count} fiches partagées",
        block_title: "Partenaires",
        shared_with: "Voient cette fiche",
        shared_by: "partagée par %{name}",
        deal_holder: "suit l'affaire",
        unshare: "Retirer le partage",
        choose: "Choisir un partenaire",
        choose_many: "Partager avec",
        share: "Partager",
        share_count: "Partager |||| Partager avec %{smart_count} partenaires",
        with_deal:
          "Lui transmettre aussi l'affaire : il en devient responsable, votre organisation la voit toujours.",
        shared: "Fiche partagée avec %{name}.",
        shared_deal: "Fiche partagée et affaire transmise à %{name}.",
        shared_many_deal:
          "Fiche partagée avec %{name} ; affaire transmise à %{holder}.",
        with_deal_many:
          "Transmettre aussi l'affaire à l'un d'eux : il en devient responsable, les autres voient la fiche, votre organisation voit toujours l'affaire.",
        with_deal_many_held:
          "Transmettre aussi l'affaire à l'un d'eux ; aujourd'hui suivie par %{name}, elle lui sera reprise.",
        deal_to: "Affaire à",
        with_deal_held:
          "Lui transmettre aussi l'affaire, aujourd'hui suivie par %{name} : elle lui sera reprise.",
        transmit_deal: "transmettre l'affaire",
        transmit_deal_held: "Reprendre l'affaire à %{name} et la transmettre",
        deal_transmitted: "Affaire transmise à %{name}.",
        unshared:
          "Partage retiré ; l'affaire éventuelle revient à votre organisation.",
        no_partner: "Aucun partenaire pour l'instant : invitez-en un.",
        all_shared: "Tous vos partenaires voient déjà cette fiche.",
        invite: {
          action: "Inviter un nouveau partenaire",
          title: "Inviter un partenaire",
          lead: "Il reçoit un e-mail à votre nom, qui nomme cette fiche, pour créer son mot de passe. S'il a déjà un compte, il est ajouté à vos partenaires et prévenu par e-mail.",
          lead_list:
            "Il reçoit un e-mail à votre nom pour créer son mot de passe. S'il a déjà un compte, il est ajouté à vos partenaires et prévenu par e-mail. Un nouveau partenaire est invité : gratuit, il ne voit que ce que vous lui partagez.",
          locale: "Langue de l'invitation",
          locale_help:
            "Celle de ses e-mails et de son compte, qu'il peut changer ensuite. Proposée d'après le pays de la fiche.",
          locale_help_list:
            "Celle de ses e-mails et de son compte, qu'il peut changer ensuite.",
          submit_list: "Inviter",
          done_new: "Invitation envoyée à %{email}.",
          done_existing:
            "%{name} avait déjà un compte : ajouté à vos partenaires, prévenu par e-mail et dans ses alertes.",
          already: "Cette personne est déjà votre partenaire.",
          already_pending:
            "Cette personne est déjà votre partenaire, mais n'a pas encore ouvert son invitation : renvoyez-la depuis « Mes partenaires ».",
          email_failed:
            "Partenaire ajouté, mais l'e-mail d'invitation n'est pas parti. Réessayez plus tard ou prévenez-le vous-même.",
          resent: "Invitation renvoyée à %{name}.",
          resend_too_soon:
            "Invitation déjà envoyée il y a moins de 24 heures : réessayez demain.",
          already_signed_in: "%{name} a déjà ouvert son compte.",
          resend_failed:
            "L'invitation n'est pas repartie. Réessayez plus tard ou prévenez-le vous-même.",
          already_member:
            "Cette personne est déjà membre de votre organisation.",
          not_a_partner:
            "Cette adresse appartient à un compte qui ne peut pas être partenaire.",
          not_authorized:
            "L'invitation de partenaires vient avec l'abonnement.",
          failed: "L'invitation n'a pas abouti. Réessayez.",
          first_name: "Prénom",
          last_name: "Nom",
          email: "E-mail professionnel",
          submit: "Inviter et partager la fiche",
        },
      },
      install: {
        title: "Installer l'application",
        intro:
          "Aubeon sur votre écran d'accueil, en plein écran, comme une application.",
        button: "Installer sur l'écran d'accueil",
        installed_title: "Application installée",
        installed: "Ouvrez Aubeon depuis l'icône de votre écran d'accueil.",
        ios_step1: "Ouvrez cette page dans Safari.",
        ios_step2:
          "Touchez le bouton Partager (un carré avec une flèche vers le haut), au besoin dans le menu « … ».",
        ios_step3: "Choisissez « Sur l'écran d'accueil », puis « Ajouter ».",
        android_step1: "Ouvrez cette page dans Chrome.",
        android_step2: "Touchez le menu ⋮ en haut à droite.",
        android_step3:
          "Choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
        already:
          "Déjà ajoutée ? Ouvrez Aubeon depuis l'icône de votre écran d'accueil.",
      },
      subscribers: {
        menu: "Abonnés",
        title: "Abonnés",
        intro:
          "Chaque côté (votre équipe ou une organisation partenaire) et chaque personne : offre, crédits, ce qu'ils vous coûtent et leur dernière activité. Le coût d'un compte ne compte que ce qu'il déclenche lui-même ; le coût commun du radar n'est pas réparti. Cette page n'est visible que de vous.",
        desktop_only: "Cet écran se consulte sur ordinateur.",
        search: "Nom, adresse e-mail ou organisation",
        month: "Mois",
        totals: {
          accounts: "Dépenses des comptes",
          unattributed: "Non attribué",
          unattributed_help:
            "Recherches de contacts faites avant le 27/10/2026, sans auteur connu.",
          common: "Coût commun du radar",
          ai_left: "Reste sous le plafond IA : %{amount}",
          airscale: "Solde Airscale",
          airscale_unknown: "Solde Airscale non relevé",
          active: "Comptes actifs",
          active_current_only: "mois en cours seulement",
        },
        airscale_counter: {
          title: "Airscale consommé par le radar",
          help: "Ce que le radar a demandé à Airscale ce mois-ci, d'après son propre journal. Le solde Airscale ci-dessus est celui de tout le compte, qui sert aussi à d'autres outils.",
          credits: "Crédits",
          cost: "Coût",
          calls: "Appels",
          calls_value: "%{found} trouvés sur %{calls}",
          found: "Trouvés",
          none: "Aucun appel à Airscale ce mois-ci.",
          operation: "Recherche",
          error: "Compteur Airscale illisible.",
          operations: {
            email: "E-mail",
            profile: "Profil LinkedIn",
            mobile: "Mobile",
            team: "Équipe",
          },
        },
        signals: {
          title: "À regarder",
          none: "Rien à signaler ce mois-ci.",
          low_balance: "Solde bas",
          high_spend: "Dépenses au-dessus de %{amount}",
          inactive: "Inactif depuis 14 jours",
          pending_request: "Demande d'abonnement en attente",
          invited_long: "Invité depuis plus de 30 jours",
        },
        columns: {
          account: "Compte",
          offer: "Offre",
          people: "Personnes",
          balance: "Solde",
          credits: "Crédits consommés",
          cost: "Dépenses",
          activity: "Dernière activité",
        },
        error: "Erreur de chargement des abonnés : %{message}",
        collapse: "Replier les personnes",
        expand: "Déplier les personnes",
        client_team: "Votre équipe",
        never: "jamais",
        suspended: "suspendu",
        no_rate: "Montants en dollars : pas de cours du dollar en base.",
        panel: {
          close: "Fermer",
          offer_price: "Prix de l'offre : %{amount} par mois",
          offer_price_help: "prix de l'offre, pas un encaissement",
          offer_countries: "%{smart_count} pays |||| %{smart_count} pays",
          offer_zones: "%{smart_count} zone |||| %{smart_count} zones",
          no_offer: "Pas d'offre payante",
          territories: "Territoires",
          world: "Licence monde",
          months: "Six derniers mois",
          month: "Mois",
          airscale: "Airscale",
          serper: "Recherche web",
          contacts_ai: "IA des contacts",
          assistant: "Assistant de la fiche",
          base: "Questions sur la base",
          total: "Total",
          credits_spent: "Crédits consommés",
          per_credit: "Coût par crédit consommé",
          usage: "Usage du mois",
          contact_requests:
            "Recherches de contacts : %{count}, dont %{found} abouties",
          questions: "Questions posées : %{count}",
          watches: "Fiches surveillées : %{count}",
          open_deals: "Affaires ouvertes : %{count}",
          logins: "Connexions : au moins %{count}",
          logins_help:
            "Minimum : une session fermée par une déconnexion n'est plus comptée.",
          ledger: "Derniers mouvements de crédits",
          no_ledger: "Aucun mouvement.",
          people: "Personnes",
          requests: "Dernières recherches de contacts",
          no_requests: "Aucune recherche.",
          recent_questions: "Dernières questions",
          no_questions: "Aucune question.",
          pending_requests: "Demandes d'abonnement en attente",
          pending_request: "%{label}, le %{date}",
          created_at: "Organisation créée le %{date}",
          next_topup: "Prochaine recharge : %{date}",
          no_topup: "Pas de recharge mensuelle",
          invited_at: "Invité le %{date}",
          accepted_at: "Invitation acceptée le %{date}",
          not_accepted: "Invitation pas encore acceptée",
          last_activity: "Dernière activité : %{date}",
          side_of: "Côté : ",
          role_partner: "Partenaire",
          role_org_admin: "Administrateur d'organisation",
          role_administrator: "Administrateur",
          role_member: "Collaborateur",
          language: "Langue : %{locale}",
          currency: "Monnaie : %{currency}",
          suspended: "Suspendu",
          resend: "Renvoyer l'invitation",
          resend_confirm:
            "Envoyer à %{email} un lien pour choisir son mot de passe ?",
          resend_done: "Lien envoyé",
          collaborator: "Ouvrir la fiche du collaborateur",
          status: "Statut",
          status_pending: "En attente",
          status_done: "Faite",
          status_error: "En échec",
          found: "Trouvés",
          credits: "Crédits",
          cost: "Coût",
          date: "Date",
          project: "Fiche",
          question: "Question",
        },
      },
      offer: {
        title: "Offre et couverture",
        desktop_only:
          "Collaborateurs, partenaires et territoires, exports et imports : sur ordinateur.",
        intro:
          "Votre offre, ce qu'elle vous ouvre, et ce que la base recense par zone et par pays pour choisir vos territoires. Pour passer abonné ou changer de territoires, demandez une formule ci-dessous : l'abonnement démarre à la réception du paiement.",
        yours: "Votre offre",
        team: "Équipe",
        team_help:
          "Membre de l'équipe : toute la base, les affaires de l'équipe et la recherche de contacts.",
        invited: "Partenaire invité",
        invited_help:
          "Invité : seulement les fiches partagées et les affaires transmises, sur lesquelles il travaille. Ni création d'affaire ni recherche de contacts ; ses territoires ne comptent pas tant qu'il n'est pas abonné.",
        subscriber: "Partenaire abonné",
        subscriber_help:
          "Abonné : toute la base de ses territoires (pays, zones ou monde), ses propres affaires et la recherche de contacts avec ses crédits.",
        world: "Monde",
        change:
          "Pour changer d'offre ou de territoires, contactez votre interlocuteur.",
        choose_zone: "Ajouter une zone",
        add_zone: "Ajouter la zone",
        estimator: "Estimer une couverture",
        estimator_help:
          "Cochez des zones ou ajoutez des pays : le total compte chaque pays une fois.",
        countries: "Pays",
        projects_30d: "Fiches sur 30 jours",
        high_score_30d: "Dont score 80+",
        projects: "En base",
        outside: "Autres pays (hors zones)",
        add_country: "Ajouter un pays",
        select: "Choisissez une zone, un pays ou le monde.",
        summary:
          "Votre sélection : %{smart_count} fiche recensée sur 30 jours dans %{countries} pays, dont %{high} à 80 ou plus (%{total} en base). |||| Votre sélection : %{smart_count} fiches recensées sur 30 jours dans %{countries} pays, dont %{high} à 80 ou plus (%{total} en base).",
        estimate_note:
          "Comptes de la base à ce jour, hors catégorie « autre ». Ils dépendent des sources branchées : l'Europe est bien couverte par les avis de marchés publics, les autres pays encore peu. Un pays sans fiche n'apparaît pas.",
      },
      zones: {
        "western-europe": "Europe de l'Ouest",
        "northern-europe": "Europe du Nord et pays baltes",
        "central-eastern-europe": "Europe centrale et orientale",
        "east-africa": "Afrique de l'Est",
        "southern-africa": "Afrique australe",
        "middle-east": "Moyen-Orient",
        oceania: "Océanie",
        "south-asia": "Asie du Sud",
        "north-africa": "Afrique du Nord",
        "west-africa": "Afrique de l'Ouest",
        "central-africa": "Afrique centrale",
        "central-asia": "Asie centrale et Caucase",
        "southeast-asia": "Asie du Sud-Est",
        "east-asia": "Asie de l'Est",
        "north-america": "Amérique du Nord",
        "latin-america": "Amérique latine et Caraïbes",
      },
      pricing: {
        title: "Formules d'abonnement",
        intro:
          "Toute la base de votre territoire, vos affaires et la recherche de contacts. Prix par mois, TVA non applicable.",
        annual: "Engagement annuel",
        monthly: "Par trimestre",
        per_month: "/ mois",
        annual_detail: "Sur 12 mois : %{total} par an, −%{saving} %",
        monthly_detail: "Minimum 3 mois, facturé %{total} par trimestre",
        complete: "Le plus complet",
        plans: {
          country: {
            name: "1 pays",
            tagline: "Pour un distributeur national.",
            scope: "Toutes les fiches du pays choisi, avec score et sources",
          },
          zone: {
            name: "1 zone",
            tagline: "Pour couvrir une région du monde.",
            scope:
              "Toutes les fiches des pays de la zone, avec score et sources",
          },
          world: {
            name: "Monde",
            tagline: "L'outil complet, sans limite de territoire.",
            scope: "Toutes les fiches de la base, dans tous les pays",
          },
        },
        choose_country: "Choisir un pays",
        choose_zone: "Choisir une zone",
        coverage:
          "%{smart_count} fiche sur 30 jours dans %{countries} pays, dont %{high} à 80 ou plus |||| %{smart_count} fiches sur 30 jours dans %{countries} pays, dont %{high} à 80 ou plus",
        feature_deals: "Vos propres affaires et leur suivi commercial",
        feature_credits:
          "%{smart_count} crédit de contacts par mois pour toute l'organisation (%{email} par e-mail trouvé, %{mobile} par mobile) |||| %{smart_count} crédits de contacts par mois pour toute l'organisation (%{email} par e-mail trouvé, %{mobile} par mobile)",
        feature_assistant:
          "Assistant : synthèse de la fiche et premier message",
        feature_alerts: "Alertes sur les fiches que vous suivez",
        request: "Demander cet abonnement",
        sent: "Demande envoyée : nous revenons vers vous pour l'activer.",
        pending:
          "Demande envoyée le %{date} : %{label}. Nous revenons vers vous pour l'activer.",
        cancel: "Annuler la demande",
        team_preview:
          "Aperçu : c'est la page que voient les partenaires. Leurs demandes vont au gestionnaire des abonnements.",
        footnote:
          "Les nombres de fiches sont ceux de la base aujourd'hui ; ils dépendent des sources branchées, encore peu nombreuses hors d'Europe. TVA non applicable, article 293 B du CGI. Partenaire invité : gratuit, sur invitation, limité aux fiches et aux affaires qu'on lui transmet.",
        requested: "Demande d'abonnement du %{date} : %{label}",
        accept: "Accepter",
        managed_by:
          "Offre et territoires gérés par le gestionnaire des abonnements",
        annual_billed: "Engagement 12 mois, facturé %{total} par an",
      },
      credits: {
        title: "Crédits",
        intro:
          "Un crédit paie une coordonnée livrée, quelle que soit la façon dont elle a été trouvée (site de la société, serveur de messagerie ou fournisseur) : %{price} par e-mail de personne obtenu pour la première fois sur une fiche, %{mobile} par mobile, %{team} par équipe d'une société. La recherche de contacts, les sociétés, les noms, les fonctions, les profils LinkedIn et la chaîne de décision sont gratuits.",
        balance: "%{smart_count} crédit |||| %{smart_count} crédits",
        reserved: "dont %{reserved} retenus par des recherches en cours",
        gauge:
          "%{count} crédit disponible, commun à toute l'équipe |||| %{count} crédits disponibles, communs à toute l'équipe",
        gauge_org:
          "%{count} crédit disponible, commun à %{org} |||| %{count} crédits disponibles, communs à %{org}",
        gauge_low: "solde bas : plus assez pour un mobile",
        gauge_empty: "plus de crédits : demandez-en à un administrateur",
        on_project:
          "Solde disponible : %{count} crédit |||| Solde disponible : %{count} crédits",
        amount: "Crédits",
        grant: "Attribuer",
        remove: "Retirer",
        granted: "Solde mis à jour.",
        note: "Motif (obligatoire)",
        confirm_title:
          "Ajouter %{smart_count} crédit à %{name} ? Motif : |||| Ajouter %{smart_count} crédits à %{name} ? Motif :",
        confirm_remove:
          "Retirer %{smart_count} crédit à %{name} ? Motif : |||| Retirer %{smart_count} crédits à %{name} ? Motif :",
        movements: "Mouvements",
        no_movement: "Aucun mouvement.",
        project: "voir la fiche",
        side_client: "Équipe du client",
        side_select: "Solde à afficher",
        members: "%{smart_count} utilisateur |||| %{smart_count} utilisateurs",
        monthly_side: "%{monthly} crédits chaque mois, communs à tous",
        pool_info:
          "Un seul solde, partagé par tous les utilisateurs, quel que soit leur nombre. Le 1er de chaque mois, il reçoit les crédits de la licence ; la moitié des crédits non utilisés est reportée, dans la limite d'un mois de crédits.",
        usage: "Consommation de l'équipe",
        usage_own: "Ma consommation",
        month: "Mois",
        no_usage: "Aucune consommation ce mois-ci.",
        disabled: "désactivé",
        movements_of: "Mouvements de %{name}",
        all_movements: "Tous les mouvements",
        columns: {
          person: "Personne",
          emails: "E-mails",
          mobiles: "Mobiles",
          teams: "Équipes",
          spent: "Crédits",
          share: "Part",
          total: "Total",
        },
        reasons: {
          monthly: "Crédits du mois",
          expiry: "Crédits non utilisés, expirés",
          plan: "Complément de la formule",
          grant: "Attribution",
          correction: "Correction",
          contacts: "Recherche de contacts",
          email: "E-mails de personnes",
          mobile: "Recherche de mobile",
          team: "Équipe d'une société",
        },
      },
      history: {
        title: "Historique des changements",
        older:
          "%{smart_count} changement plus ancien |||| %{smart_count} changements plus anciens",
        empty: "Aucun changement constaté depuis la création de la fiche.",
        changed: "%{old} → %{new}",
        added: "%{new} (nouveau)",
        contradiction:
          "Une source plus récente indique « %{new} » ; la fiche reste en « %{old} », la phase ne recule pas.",
      },
      published_on: "Publié le %{date}",
      collected_on: "Collecté le %{date}",
      published_and_collected:
        "Publié le %{published} · collecté le %{collected}",
      // Mention exigée par l'Open Database License (marchés de la DGCP, République dominicaine)
      odbl_notice:
        "Contient des informations de la base de %{publisher}, mises à disposition sous licence",
      // Mention exigée par la licence CC BY 4.0 de Postor Abierto (procédures de ComprasMX)
      postor_notice:
        "Données de Postor Abierto (postor.com.mx), consultées le %{date}. %{citation}.",
      // Mention exigée par la licence PDL 1.0 du ministère japonais de l'Environnement (source et transformation)
      jpeia_notice:
        "Source : « 環境影響評価情報支援ネットワーク » (環境省, assess.env.go.jp), traduit et résumé par Aubeon Project.",
      // Mention exigée par les conditions d'utilisation de l'API de simap.ch
      // Mention exigée par l'Open Government Licence – Toronto (formule de la licence, gardée en anglais)
      toronto_notice:
        "Contains information licensed under the Open Government Licence – Toronto. (Contient des informations sous la licence ouverte de la Ville de Toronto.)",
      // Avertissement exigé par les conditions d'utilisation des données de la ville de Chicago (texte gardé en anglais)
      // Mention exigée par les conditions de réutilisation du BOE (texte imposé, gardé en espagnol)
      boe_notice: "Basado en datos de la",
      chicago_notice:
        "This site provides applications using data that has been modified for use from its original source, www.cityofchicago.org, the official website of the City of Chicago. The City of Chicago makes no claims as to the content, accuracy, timeliness, or completeness of any of the data provided at this site. The data provided at this site is subject to change at any time. It is understood that the data provided at this site is being used at one’s own risk. (Données de la ville de Chicago, modifiées pour cet usage ; la ville ne garantit ni leur exactitude ni leur actualité.)",
      simap_notice:
        "Ceci n'est pas une publication officielle. Les données publiées sur la plateforme www.simap.ch font foi.",
      last_news: "Dernière nouvelle le %{date}",
      summary: {
        score: "Score",
        project: "Projet",
        contact: "À joindre",
        news: "Dernière nouvelle",
        no_amount: "montant inconnu",
        email: "e-mail",
        phone: "téléphone",
        no_reachable: "Aucun contact joignable.",
        no_contact: "Aucun contact trouvé.",
        see_contacts: "Voir les contacts",
        stale:
          "%{date} · plus de 12 mois : vérifier que le projet est toujours en cours",
      },
      sources_count: "%{smart_count} source |||| %{smart_count} sources",
      stale_news:
        "Aucune nouvelle depuis le %{date} : vérifier que le projet est toujours en cours avant de prospecter.",
      stamps: {
        extracted: "Sourcé",
        inferred: "Déduit IA",
        entered: "Saisi",
      },
      confidence: "confiance %{value} %",
      source_ref: "Source %{n}",
      to_check: "À vérifier : confiance faible",
      actions: {
        label: "Actions sur le projet",
        credits_short: "Crédits insuffisants pour une recherche",
        invited:
          "Offre invité : le suivi et la recherche de contacts sont réservés aux abonnés. Pour suivre ce projet, demandez à votre contact de vous transmettre l'affaire.",
        see_offer: "Voir l'offre",
      },
      company_table: {
        name: "Entreprise",
        roles: "Rôles dans les fiches",
        countries: "Pays des projets",
        projects: "Projets",
        contacts: "Contacts",
        more: "+ %{count}",
      },
      panel: {
        label: "Fiche du projet",
        position: "%{position} sur %{total}",
        previous: "Fiche précédente (K)",
        next: "Fiche suivante (J)",
        close: "Fermer (Échap)",
        keys: "J / K pour passer d'une fiche à l'autre",
      },
    },
    partnerships: {
      mine: {
        title: "Mes partenaires",
        intro:
          "Les personnes extérieures avec qui votre organisation travaille : vous leur partagez des fiches et leur transmettez des affaires. Elles ne voient rien d'autre de votre travail.",
        invite: "Inviter un partenaire",
        name: "Nom",
        organisation: "Organisation",
        offer: "Offre",
        invited: "Invité",
        subscriber: "Abonné",
        shares: "Fiches partagées",
        deals: "Affaires transmises",
        since: "Depuis",
        end: "Mettre fin",
        invite_pending: "Invitation non ouverte, envoyée le %{date}",
        resend: "Renvoyer l'invitation",
        resend_later: "renvoi possible 24 h après",
        end_title: "Mettre fin au partenariat avec %{name} ?",
        end_confirm:
          "Les fiches que vous lui avez partagées ne lui seront plus visibles et les affaires transmises reviennent à votre organisation. Les contacts qu'il a trouvés lui-même restent à lui.",
        ended: "Partenariat terminé avec %{name}.",
        empty: "Aucun partenaire pour l'instant.",
        not_available: "Inviter des partenaires vient avec l'abonnement.",
        history: {
          toggle: "Historique",
          empty: "Aucune fiche envoyée à ce partenaire pour l'instant.",
          shared: "Envoyée le %{date}",
          shared_by: "Envoyée le %{date} par %{name}",
          sees: "voit la fiche",
          revoked: "partage retiré le %{date}",
          no_deal: "Fiche seule, sans affaire transmise",
          deal: "Affaire transmise : %{stage}",
          next_action: "prochaine action le %{date}",
        },
      },
      hosts: {
        title: "Partenariats",
        intro:
          "Les organisations qui travaillent avec vous et vous partagent des fiches ou des affaires. Vous ne voyez de leur travail que ce qu'elles vous partagent.",
        since: "Depuis le %{date}",
        shares:
          "%{smart_count} fiche partagée |||| %{smart_count} fiches partagées",
        deals:
          "%{smart_count} affaire transmise |||| %{smart_count} affaires transmises",
        leave: "Quitter ce partenariat",
        leave_title: "Quitter le partenariat avec %{name} ?",
        leave_confirm:
          "Vous ne verrez plus les fiches partagées et les affaires transmises reviennent à %{name}. Vos notes restent sur ces affaires, chez elle.",
        left: "Vous avez quitté le partenariat avec %{name}.",
        empty: "Aucune organisation ne travaille avec vous pour l'instant.",
        not_partner: "Cette page sert aux partenaires d'une organisation.",
      },
    },
    onboarding: {
      tips: {
        done: "Compris",
        progress: "{{current}} sur {{total}}",
        projects: {
          score: {
            title: "Le score ETT",
            body: "De 0 à 100 : plus il est haut, plus le projet a besoin d'étanchéité du béton. Ouvrez une fiche pour voir chaque critère.",
          },
          filters: {
            title: "Votre territoire",
            body: "Filtrez par pays et par montant ; enregistrez le filtre comme veille pour être prévenu des nouvelles fiches.",
          },
        },
        project: {
          stamps: {
            title: "Sourcé ou déduit",
            body: "« Sourcé » : la valeur est citée mot pour mot dans un document. « Déduit » : l'IA l'a déduite, avec un niveau de confiance.",
          },
          contacts: {
            title: "Qui contacter",
            body: "Lancez la recherche de contacts : elle est gratuite et place chaque personne dans la chaîne de décision. Seuls les e-mails et les mobiles obtenus consomment des crédits.",
          },
          contacts_invited: {
            title: "Qui contacter",
            body: "Les contacts de chaque projet sont réservés aux abonnés : voyez l'offre pour les débloquer.",
          },
        },
        daily: {
          reasons: {
            title: "Pourquoi celui-là",
            body: "Chaque ligne dit ce qui a bougé : nouvelle fiche, phase, titulaire, budget. La sélection change chaque nuit.",
          },
        },
        alerts: {
          saved: {
            title: "Vos réglages",
            body: "Récapitulatif par e-mail, sociétés des fiches que vous surveillez et veilles : tout se règle ici.",
          },
        },
        map: {
          country: {
            title: "La carte",
            body: "Cliquez sur un pays pour voir ses fiches.",
          },
          country_mobile: {
            title: "La carte",
            body: "Touchez un pays pour voir ses fiches.",
          },
        },
      },
      menu: {
        replay: "Revoir la présentation",
        tips: "Réafficher les aides des écrans",
        tips_reset: "Les aides réapparaîtront à l'ouverture de chaque écran",
        tips_error: "Les aides n'ont pas pu être réactivées",
      },
      label: "Présentation d'Aubeon",
      skip: "Passer",
      next: "Suivant",
      previous: "Précédent",
      example: "Exemple",
      paused: "En pause",
      pause: "Pause",
      resume: "Reprendre",
      units: { millions: "%{amount} M %{currency}" },
      stamp: { extracted: "Sourcé", inferred: "Déduit" },
      fields: {
        structure_type: "Ouvrage",
        budget_amount: "Montant",
        start_date: "Début",
        phase: "Phase",
        city: "Ville",
      },
      scene: {
        "1": {
          of: "1 sur 6",
          title: "Les grands chantiers béton, repérés avant les autres.",
          kicker: "Veille mondiale",
          projects: "projets suivis",
          sources: "sources lues chaque nuit",
          countries: "pays couverts",
          lead: "Chaque nuit, Aubeon lit les avis de marché, les délibérations, les permis et la presse du monde entier.",
        },
        "2": {
          of: "2 sur 6",
          title: "Un avis devient une fiche.",
          kicker: "Repérés tôt, prouvés",
          sources: {
            notice: "Avis de marché",
            deliberation: "Délibération",
            permit: "Permis",
            press: "Presse",
          },
          lead: "%{extracted} valeurs relevées mot pour mot dans leur document, %{inferred} déduites et marquées comme telles.",
        },
        "3": {
          of: "3 sur 6",
          title: "Un score, critère par critère.",
          kicker: "Qualifiés pour l'ETT",
          ring: "Score %{score} sur 100",
        },
        "4": {
          of: "4 sur 6",
          title: "La chaîne de décision, pas juste un nom.",
          kicker: "Qui décide",
          lead: "Maître d'ouvrage, bureau d'études, entreprise : chacun avec son rôle dans la décision.",
          lead_invited:
            "Les noms et les contacts de chaque maillon sont réservés aux abonnés.",
          hidden: "Nom réservé aux abonnés",
          unknown: "À trouver",
          groups: {
            owner: "Maître d'ouvrage",
            design: "Bureau d'études",
            contractor: "Entreprise",
          },
          filler: {
            owner: "Régie des eaux du Nord",
            design: "Ingénierie Atlas",
            contractor: "Bâtisseurs réunis",
          },
        },
        "5": {
          of: "5 sur 6",
          title: "Vos 10 du jour, et une alerte dès qu'un projet bouge.",
          kicker: "Chaque matin",
          lead: "Le radar choisit pour vous, chaque nuit, les fiches qui ont bougé.",
          project: "Projet",
          no_score: "—",
        },
        "6": {
          of: "6 sur 6",
          title: "À vous.",
          kicker: "À vous",
          title_invited: "Choisissez votre zone.",
          zone: "Votre zone d'intérêt",
          zone_placeholder: "Choisir une zone ou un pays",
          zones: "Zones",
          countries: "Pays",
          error: "La zone n'a pas pu être enregistrée",
          saved: "Zone enregistrée",
          offer: "Voir l'offre",
          daily: "Ouvrir mes 10 du jour",
          explore: "Explorer",
        },
      },
    },
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      import: {
        title: "Importer des entreprises",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        noop: "Les contacts sélectionnés ont déjà cette étiquette",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    deals: {
      name: "Affaire |||| Affaires",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Catégorie",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
        next_action: "Prochaine action",
        next_action_type: "Type de la prochaine action",
        next_action_date: "Date de la prochaine action",
        project_id: "Fiche projet",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
      },
      field_categories: {
        misc: "Divers",
      },
      filters: {
        only_mine: "Seulement les affaires que je gère",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      org: {
        title: "Mon organisation",
        none: "Vous ne faites partie d'aucune organisation partenaire.",
        invited_only:
          "Mon organisation s'ouvre quand vous passez abonné : vous pourrez alors inviter vos collègues et régler votre pipeline. Voir les formules :",
        invited_only_closed:
          "Mon organisation s'ouvre quand vous passez abonné : vous pourrez alors inviter vos collègues et régler votre pipeline. Pour vous abonner, contactez votre interlocuteur.",
        intro_admin:
          "Invitez vos collègues, qui partagent vos affaires, vos contacts et vos crédits, et réglez le pipeline de vos affaires propres. Les affaires qu'on vous transmet gardent leurs étapes d'origine.",
        intro_member:
          "Vos collègues partagent avec vous affaires, contacts et crédits. Seul un administrateur de l'organisation invite des membres et règle le pipeline.",
        name: "Nom de l'organisation",
        saved: "Enregistré",
        members: "Membres",
        seats: "%{active} sur %{limit} places",
        full_hint:
          "Votre organisation compte %{limit} membres actifs, le maximum. Suspendez un membre pour inviter ou réactiver un collègue.",
        full_error:
          "Votre organisation est pleine : suspendez un membre pour inviter ou réactiver un collègue.",
        admin: "Administrateur",
        disabled: "Suspendu",
        make_admin: "Nommer administrateur",
        remove_admin: "Retirer l'administration",
        disable: "Suspendre",
        enable: "Réactiver",
        invite: "Inviter un collègue",
        invite_hint:
          "Il reçoit un e-mail pour choisir son mot de passe, avec la même offre et les mêmes territoires que l'organisation.",
        send_invite: "Envoyer l'invitation",
        invited: "Invitation envoyée à %{email}",
        pipeline: "Pipeline de l'organisation",
        pipeline_hint:
          "Étapes de vos affaires propres, dans l'ordre. Cochez « fin » pour les étapes qui closent une affaire (plus d'action en retard). Une étape occupée par une affaire ne peut pas être retirée.",
        stage_name: "Nom de l'étape",
        closed: "fin",
        up: "Monter",
        down: "Descendre",
        remove_stage: "Retirer l'étape",
        stage_count: "%{smart_count} affaire |||| %{smart_count} affaires",
        stage_used:
          "%{smart_count} affaire dans cette étape : déplacez-la vers une autre étape avant de la retirer. |||| %{smart_count} affaires dans cette étape : déplacez-les vers une autre étape avant de la retirer.",
        add_stage: "Ajouter une étape",
        settings_hint: "Régler le pipeline de votre organisation",
        tab_mine: "Mes affaires",
        tab_transmitted: "Transmises",
        hosts_label: "Organisation qui transmet",
        host_overdue: "Une action est en retard",
        tab_todo: "À faire",
        todo_empty: "Aucune prochaine action prévue.",
      },
      invited: {
        banner:
          "Faites le suivi commercial de ces affaires. Avec un abonnement, vous les faites avancer d'étape en étape, vous datez vos prochaines actions avec rappel, vous créez vos propres affaires sur votre territoire et vous cherchez les contacts.",
        offers: "Voir les offres",
        intro:
          "Affaires que vos partenaires vous ont transmises. Vous voyez leur étape et vous les commentez : chaque note prévient l'organisation qui vous l'a transmise.",
        stage: "Étape",
        last_note: "Dernière note",
        no_note: "Aucune note",
        add_note: "Ajouter une note",
        open_project: "Voir la fiche",
        empty: "Aucune affaire ne vous a encore été transmise.",
      },
      board: {
        collapse: "Replier la colonne « %{stage} » (pour vous seul)",
        expand: "Déplier la colonne « %{stage} »",
        settings: "Régler le pipeline",
        settings_hint:
          "Étapes, étapes de fin et catégories : communes à toute l'équipe, réglées par un administrateur",
      },
      map: {
        view_board: "Tableau",
        view_list: "Liste",
        label: "Carte des affaires",
        loading: "Chargement des affaires…",
        placed:
          "%{smart_count} affaire sur la carte |||| %{smart_count} affaires sur la carte",
        late: "%{smart_count} en retard",
        unplaced:
          "%{smart_count} affaire sans ville placée, pas sur la carte |||| %{smart_count} affaires sans ville placée, pas sur la carte",
        same_place:
          "%{smart_count} affaire à cet endroit |||| %{smart_count} affaires à cet endroit",
        empty:
          "Aucune affaire n'est rattachée à une fiche dont la ville est placée.",
      },
      suggestions: {
        title: "Le radar suggère",
        take: "Prendre",
        dismiss: "Écarter",
        reason_phase: "la fiche est passée en appel d'offres",
        reason_company: "%{company} est arrivée (%{role})",
        reason_replied: "réponse reçue il y a plus de 14 jours, sans suite",
      },
      linkedin_message: {
        copy: "Copier le message LinkedIn",
        hint: "À envoyer si la personne a accepté votre demande de connexion",
      },
      next_action_types: {
        follow_up: "Relancer",
        call: "Appeler",
        send_documentation: "Envoyer la documentation",
        propose_meeting: "Proposer un rendez-vous",
        present: "Présenter au bureau d'études",
        site_visit: "Visite de chantier",
        check_cctp: "Vérifier le CCTP",
        contact_contractor: "Contacter l'entreprise",
        linkedin_dm: "Envoyer le 1er message LinkedIn",
        other: "Autre",
      },
      due: {
        tomorrow: "Demain",
        in3: "Dans 3 jours",
        monday: "Lundi",
        in2weeks: "Dans 2 semaines",
      },
      journal: {
        title: "Journal",
        empty: "Aucun échange noté.",
        log: "Noter un échange",
        kind: "Type",
        person: "Personne",
        company: "La société",
        direction_out: "Envoyé",
        direction_in: "Reçu",
        note: "Note (facultative, 500 caractères)",
        save: "Noter",
        saved: "Échange noté",
        kinds: {
          email: "E-mail",
          linkedin: "LinkedIn",
          call: "Appel",
          meeting: "Rendez-vous",
          site_visit: "Visite",
          documentation: "Documentation",
        },
        reply: {
          pending: "En attente",
          replied: "A répondu",
          no_reply: "Pas de réponse",
          declined: "Refus",
        },
        follow_up_offer: "Relancer %{name} le %{date} ?",
        follow_up_company: "Relancer la société le %{date} ?",
        accept: "Oui",
        later: "Plus tard",
        stage_offer:
          "Premier message parti : passer l'affaire en « %{stage} » ?",
        stage_move: "Passer",
      },
      my_day: {
        title: "Ma journée",
        empty: "Rien d'urgent aujourd'hui.",
        error: "Impossible de charger votre journée.",
        overdue: "En retard",
        today: "Aujourd'hui",
        replies: "Réponses à traiter",
        no_action: "Sans suite",
        replied: "%{name} a répondu",
        replied_company: "Réponse reçue",
      },
      pilot: {
        menu: "Pilotage",
        loading: "Chargement des chiffres…",
        error: "Impossible de charger le pilotage.",
        title: "Pilotage",
        intro_all: "Toute l'équipe.",
        intro_mine: "Vos chiffres.",
        activity: "Échanges envoyés par semaine",
        reply_rates: "Taux de réponse (90 jours, messages de plus de 7 jours)",
        without_action: "Affaires sans prochaine action",
        overdue: "Actions en retard",
        stuck: "Affaires à la même étape depuis plus de 30 jours",
        stuck_since: "Suivi des étapes depuis le %{date}",
        stuck_since_none:
          "Aucun changement d'étape noté encore : les affaires comptent depuis leur création.",
        conversion: "Passage d'une étape à la suivante",
        conversion_line: "%{reached} sur %{entered}",
        prescriptions: "Prescriptions obtenues par trimestre",
        created: "Affaires créées par mois",
        none: "Pas encore de données.",
      },
      next_action_editor: {
        set: "Prévoir une action",
        change: "Changer",
        type: "Action",
        note: "Note (facultative)",
        note_required: "Une note est nécessaire pour « Autre »",
        other_day: "Autre jour",
        done: "Fait",
        saved: "Prochaine action enregistrée",
        none: "Sans prochaine action",
        filter_none: "Sans prochaine action",
        follow_up_person: "Relancer %{name}",
      },
      follow_up: {
        title: "Suivi commercial",
        follow: "Suivre ce projet",
        help: "Créez l'affaire de ce projet pour noter son étape, la prochaine action et les échanges.",
        open_deal: "Ouvrir l'affaire",
        open_project: "Ouvrir la fiche",
        no_action: "Aucune action prévue",
        overdue: "En retard",
        partners_following:
          "Un partenaire suit aussi ce projet de son côté : %{names} |||| Des partenaires suivent aussi ce projet de leur côté : %{names}",
        empty_list:
          "Aucune affaire en cours. Ouvrez une fiche et touchez « Suivre ce projet ».",
      },
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      import: {
        title: "Importer des affaires",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Collaborateur |||| Collaborateurs",
      intro:
        "Les personnes de votre société : elles voient toute la base et vos affaires. Pour un distributeur ou un installateur, passez par Partenaires.",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        secondary_email: "E-mail secondaire",
        secondary_emails: "E-mails secondaires",
        administrator: "Admin",
        disabled: "Désactivé",
      },
      create: {
        error: "Une erreur s'est produite lors de l'ajout du collaborateur.",
        success:
          "Collaborateur ajouté : il recevra bientôt un e-mail pour choisir son mot de passe.",
        title: "Ajouter un collaborateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Collaborateur mis à jour",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouveau collaborateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
      empty: "Aucune étiquette pour le moment.",
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      code: {
        send: "Recevoir un code par e-mail",
        sent: "Si cette adresse a un compte, un code vient de lui être envoyé.",
        help: "Saisissez le code à six chiffres envoyé à %{email}. Pensez à regarder dans les indésirables.",
        label: "Code reçu par e-mail",
        invalid: "Code incorrect ou expiré. Demandez-en un nouveau.",
        too_many:
          "Trop de demandes : patientez une minute avant de redemander un code.",
        change_email: "Changer d'adresse",
        resend: "Renvoyer un code",
        use_password: "Se connecter avec un mot de passe",
        use_code: "Se connecter avec un code reçu par e-mail",
      },
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Aubeon",
    },
    common: {
      account_manager: "Responsable de compte",
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    changelog: {
      title: "Notes de version",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      stepper: {
        install: "Installer Aubeon",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    data_import: {
      button: "Importer un fichier CSV",
      complete:
        "Import terminé. %{importCount} enregistrements importés, %{errorCount} erreurs",
      csv_file: "Fichier CSV",
      error:
        "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
      in_progress: "Import en cours…",
      progress:
        "%{importCount} / %{rowCount} enregistrements importés, avec %{errorCount} erreurs.",
      remaining_time: "Temps restant estimé :",
      resource: "Ressource",
      sample_download: "Télécharger un exemple CSV",
      sample_hint:
        "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
      start: "Démarrer l'import",
      stop: "Arrêter l'importation",
      stopped:
        "Import arrêté. %{importCount} enregistrements importés, %{errorCount} erreurs",
      title: "Importer des données",
    },
    header: {
      import_data: "Importer depuis JSON",
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer depuis JSON",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        closed_stages: "Étapes de fin",
        closed_stages_help:
          "Une affaire arrivée à l'une de ces étapes est terminée : elle n'est plus comptée parmi les affaires en cours du tableau de bord, n'apparaît plus sur la carte et ne déclenche plus d'alerte d'action en retard. Cochez-y toute étape que vous ajoutez pour clore une affaire (par exemple « Abandonné »). Une étape nouvelle, qui vient d'être ajoutée, se coche après l'enregistrement.",
        stages: "Étapes",
        stage_counts:
          "Affaires par étape : %{items}. Une étape occupée ne peut pas être retirée : déplacez d'abord ses affaires vers une autre étape.",
        admin_only:
          "Ces réglages valent pour toute votre équipe et pour les partenaires à qui vous transmettez une affaire. Seul un administrateur peut les modifier : tout le monde doit voir les mêmes étapes, et le tableau de bord, la carte et les alertes doivent compter les affaires de la même façon pour chacun. Pour alléger son propre écran, chacun peut replier les colonnes qui ne lui servent pas depuis l'écran Affaires, sans rien changer pour les autres.",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des affaires : %{items}",
        stages_in_use:
          "Étape encore utilisée par des affaires : %{items}. Déplacez-les vers une autre étape avant de retirer l'étape.",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    currency: "Monnaie",
    navigation: {
      home: "Accueil",
      account_install: "Paramètres : application à installer",
      label: "Navigation CRM",
      radar: "Radar",
    },
    profile: {
      add_secondary_email: "Ajouter un e-mail",
      email_taken: "%{email} est déjà utilisée par un autre utilisateur",
      no_secondary_emails: "Aucun",
      secondary_email_invalid: "%{email} n'est pas une adresse e-mail valide",
      secondary_email_is_primary: "%{email} est déjà votre adresse principale",
      secondary_email_taken:
        "%{email} est déjà utilisée par un autre utilisateur",
      too_many_secondary_emails:
        "Vous ne pouvez pas ajouter plus de 10 adresses e-mail secondaires",
      secondary_emails_help:
        "Autres adresses depuis lesquelles vous envoyez des e-mails. Laissez-en une vide pour la supprimer.",
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Aubeon traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
